"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3094],{

/***/ 69119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfDay; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 43171:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/body.413e5f4c.jpg","height":3500,"width":3500,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAYEAEAAwEAAAAAAAAAAAAAAAAAERMhYf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCvbZyAAf/Z","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 59772:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/nlift.a614e00a.jpg","height":1120,"width":1120,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAZEAACAwEAAAAAAAAAAAAAAAAAAQIREhP/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8ArsN9Gnq0wAB//9k=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 70166:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/nrose.6b6406dd.jpg","height":1120,"width":1120,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAaEAACAgMAAAAAAAAAAAAAAAAAAQIREyEx/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AK/FvNu74AAP/9k=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 14373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ FormScrollableContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87379);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82580);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48286);
/* harmony import */ var src_components_ScrollableContent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53402);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81041);
/* harmony import */ var src_hooks_useDelayedEffect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36458);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var Content = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__["default"])(framer_motion__WEBPACK_IMPORTED_MODULE_7__/* .motion.div */ .E.div).withConfig({
    displayName: "FormScrollableContent__Content",
    componentId: "sc-b673640a-0"
})(_templateObject());
/**
 * Form container, which automatically scrolls to field errors
 */ var FormScrollableContent = function(_param) {
    var children = _param.children, _simplebar = _param.simplebar, simplebar = _simplebar === void 0 ? true : _simplebar, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "children",
        "simplebar"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var formikCtx = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(formik__WEBPACK_IMPORTED_MODULE_2__/* .FormikContext */ .k5);
    var scrollToNearestError = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        var ref1;
        var scrollContainer = simplebar ? (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.querySelector(".simplebar-content-wrapper") : ref.current;
        if (scrollContainer) {
            var errorEl = document.querySelector("[aria-invalid=true]");
            if (errorEl) {
                scrollContainer.scrollTo({
                    top: errorEl.offsetTop - 150,
                    behavior: "smooth"
                });
            }
        }
    }, [
        simplebar
    ]);
    (0,src_hooks_useDelayedEffect__WEBPACK_IMPORTED_MODULE_5__/* .useDelayedEffect */ .W)(function() {
        var ref1;
        var form = (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.querySelector("form");
        form === null || form === void 0 ? void 0 : form.addEventListener("submit", scrollToNearestError);
        return function() {
            form === null || form === void 0 ? void 0 : form.removeEventListener("submit", scrollToNearestError);
        };
    }, 2000);
    (0,react_use__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
        if (formikCtx) {
            scrollToNearestError();
        }
    }, [
        formikCtx === null || formikCtx === void 0 ? void 0 : formikCtx.submitCount
    ]);
    if (simplebar) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_ScrollableContent__WEBPACK_IMPORTED_MODULE_4__/* .ScrollableContent */ .t, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
            ref: ref
        }, props), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Content, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        ref: ref
    }, props), {
        children: children
    }));
};


/***/ }),

/***/ 8183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ LoaderTransition; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97182);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81041);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14332);
/* harmony import */ var src_components_common_Loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15572);
/* harmony import */ var src_utils_theme_useTransition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47977);











/**
 * Component used to present a loader when waiting for some data to be loaded and then rendered.
 * If no children or null children is provided, then the loader is displayed.
 *
 * @param debounce
 * @param animateAlways
 * @param contentKey
 * @param Loader
 * @param withoutWrapper - disable wrapping contents in motion.div element. If you are using withoutWrapper make sure that children and loader components are motion components.
 * @param props
 * @constructor
 */ var LoaderTransition = function(_param) {
    var _debounce = _param.debounce, debounce = _debounce === void 0 ? 100 : _debounce, animateAlways = _param.animateAlways, contentKey = _param.contentKey, _Loader = _param.Loader, Loader = _Loader === void 0 ? src_components_common_Loader__WEBPACK_IMPORTED_MODULE_2__/* .Loader */ .aN : _Loader, withoutWrapper = _param.withoutWrapper, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "debounce",
        "animateAlways",
        "contentKey",
        "Loader",
        "withoutWrapper",
        "children"
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,react_use__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(debounce), 1), showLoader = ref[0];
    var childKey = contentKey || (children === null || children === void 0 ? void 0 : children.key) || "content";
    var shouldShowLoader = showLoader();
    var shouldAnimate = animateAlways || shouldShowLoader;
    var acceleratedTransition = (0,src_utils_theme_useTransition__WEBPACK_IMPORTED_MODULE_3__/* .useTransition */ .Y)(1, function(e) {
        return e.accelerated;
    });
    var deceleratedTransition = (0,src_utils_theme_useTransition__WEBPACK_IMPORTED_MODULE_3__/* .useTransition */ .Y)(1, function(e) {
        return e.decelerated;
    });
    var animationProps = {
        animate: props.animate || {
            opacity: 1,
            y: 0,
            transition: deceleratedTransition
        },
        initial: props.initial || {
            opacity: 0,
            y: 10
        },
        exit: props.exit || {
            opacity: 0,
            y: 10,
            transition: acceleratedTransition
        }
    };
    var childProps = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, shouldAnimate ? animationProps : {}, props);
    var loaderProps = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        key: "loader"
    }, animationProps, props);
    var child = withoutWrapper ? children ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(children, childProps) : shouldShowLoader ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Loader, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, loaderProps)) : null : children ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(framer_motion__WEBPACK_IMPORTED_MODULE_8__/* .motion.div */ .E.div, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, childProps), {
        key: childKey
    }), children) : shouldShowLoader ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Loader, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, loaderProps)) : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_10__/* .AnimatePresence */ .M, {
        exitBeforeEnter: true,
        children: child
    });
};


/***/ }),

/***/ 5311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ SplitRow; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73098);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-column-gap: ",
        "px;\n  grid-auto-flow: column;\n  grid-auto-columns: 1fr;\n\n  ",
        " {\n    grid-auto-flow: row;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/**
 * Align contents in row with gaps between.
 * @param children
 * @constructor
 */ var SplitRow = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    displayName: "SplitRow",
    componentId: "sc-820cdf26-0"
})(_templateObject(), function(param) {
    var theme = param.theme, _spacing = param.spacing, spacing = _spacing === void 0 ? 1 : _spacing;
    return theme.spacing.gap * spacing;
}, src_styles_designs__WEBPACK_IMPORTED_MODULE_1__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop);


/***/ }),

/***/ 36163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "My": function() { return /* binding */ StyledFormH2; },
/* harmony export */   "N": function() { return /* binding */ FormH1; },
/* harmony export */   "YV": function() { return /* binding */ FormH2; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var src_components_common_typography_Header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29894);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 300;\n  font-size: 21px;\n  line-height: 130%;\n\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n\n  color: ",
        ";\n  margin-bottom: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var FormH1 = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].h1.withConfig({
    displayName: "Form__FormH1",
    componentId: "sc-4f3e0556-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
}, function(param) {
    var theme = param.theme;
    return theme.spacing.gap * 2.5;
});
var FormH2 = src_components_common_typography_Header__WEBPACK_IMPORTED_MODULE_1__.H2;
var StyledFormH2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(FormH2).withConfig({
    displayName: "Form__StyledFormH2",
    componentId: "sc-4f3e0556-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
});


/***/ }),

/***/ 51306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ Paragraph; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 1.5;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].p.withConfig({
    displayName: "Text__Paragraph",
    componentId: "sc-ee167d0d-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
});


/***/ }),

/***/ 2898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ Live; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _summer_jst_react_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55537);




var Live = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_summer_jst_react_icon__WEBPACK_IMPORTED_MODULE_1__/* .IconBox */ .zb, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32 57.9048C46.3068 57.9048 57.9048 46.3068 57.9048 32C57.9048 17.6932 46.3068 6.09524 32 6.09524C17.6932 6.09524 6.09524 17.6932 6.09524 32C6.09524 46.3068 17.6932 57.9048 32 57.9048ZM32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "32.0001",
                cy: "32.0001",
                r: "13.7143"
            })
        ]
    }));
};


/***/ }),

/***/ 36458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useDelayedEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable react-hooks/exhaustive-deps */ 
var useDelayedEffect = function(effect, delay) {
    var deps = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
        delay
    ];
    var timeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        timeoutRef.current = setTimeout(effect, delay);
        return function() {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, deps);
};


/***/ }),

/***/ 56760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ fetchEventsList; }
});

// UNUSED EXPORTS: useEventsListQuery

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/models/query.ts
var query = __webpack_require__(19162);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/modules/events/graphql/events.fragment.ts
var events_fragment = __webpack_require__(67062);
// EXTERNAL MODULE: ./src/utils/gql/query.ts
var gql_query = __webpack_require__(72493);
;// CONCATENATED MODULE: ./src/modules/events/graphql/events-list.query.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  query EventsList($filters: events_filter, $sort: [String]) {\n    events(filter: $filters, sort: $sort, limit: -1) {\n      ...events\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var eventsListGqlQuery = (0,gql_query/* gql */.Ps)(_templateObject(), events_fragment/* eventsGqlFragment */.g);

// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/hooks/useAPIs.ts
var hooks_useAPIs = __webpack_require__(53100);
;// CONCATENATED MODULE: ./src/modules/events/hooks/useEventsListQuery.ts







var fetchEventsList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(apis, variables) {
        var directus;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        apis.directus()
                    ];
                case 1:
                    directus = _state.sent();
                    return [
                        2,
                        directus.query(eventsListGqlQuery, (0,_object_spread/* default */.Z)({
                            sort: [
                                "sort"
                            ]
                        }, variables)).then(function(a) {
                            return a.events;
                        })
                    ];
            }
        });
    });
    return function fetchEventsList(apis, variables) {
        return _ref.apply(this, arguments);
    };
}();
var useEventsListQuery = function() {
    var apis = useAPIs();
    return useQuery(QueryKey.EventsList, function() {
        return fetchEventsList(apis);
    });
};


/***/ }),

/***/ 73082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useFlattenEvent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_hooks_directus_useTranslateItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70057);




var useFlattenEvent = function(event) {
    var translateFn = (0,src_hooks_directus_useTranslateItem__WEBPACK_IMPORTED_MODULE_1__/* .useTranslateItem */ .L)();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var ref, ref1, ref2;
        var translatedEvent = translateFn(event);
        var translatedEventType = event.type != null ? translateFn(event.type) : null;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, translatedEventType, translatedEvent), {
            id: translatedEvent.id,
            name: translatedEvent.name,
            description: translatedEvent.description || (translatedEventType === null || translatedEventType === void 0 ? void 0 : translatedEventType.description) || "",
            excerpt: translatedEvent.excerpt || (translatedEventType === null || translatedEventType === void 0 ? void 0 : translatedEventType.excerpt) || "",
            type: translatedEventType,
            tags: (((ref = event.tags) === null || ref === void 0 ? void 0 : ref.length) > 0 ? event.tags : ((ref1 = event.type) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.tags) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? event.type.tags : []).map(function(a) {
                return translateFn(a.tags_id);
            })
        });
    }, [
        event,
        translateFn
    ]);
};


/***/ }),

/***/ 93928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useUpcomingEventsListQuery; }
/* harmony export */ });
/* unused harmony export fetchUpcomingEventsList */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20414);
/* harmony import */ var src_models_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19162);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69119);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78420);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88767);
/* harmony import */ var src_hooks_useAPIs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53100);
/* harmony import */ var src_modules_events_hooks_useEventsListQuery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56760);







var fetchUpcomingEventsList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(apis) {
        var events;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,src_modules_events_hooks_useEventsListQuery__WEBPACK_IMPORTED_MODULE_3__/* .fetchEventsList */ .l)(apis, {
                            filters: {
                                endDate: {
                                    _gte: (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(new Date()).toISOString()
                                }
                            }
                        })
                    ];
                case 1:
                    events = _state.sent();
                    return [
                        2,
                        events.filter(function(event) {
                            return (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(event.endDate).getTime() > new Date().getTime();
                        }).sort(function(a, b) {
                            return (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(a.startDate).getTime() - (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(b.startDate).getTime();
                        })
                    ];
            }
        });
    });
    return function fetchUpcomingEventsList(apis) {
        return _ref.apply(this, arguments);
    };
}();
var useUpcomingEventsListQuery = function() {
    var apis = (0,src_hooks_useAPIs__WEBPACK_IMPORTED_MODULE_2__/* .useAPIs */ .V)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)(src_models_query__WEBPACK_IMPORTED_MODULE_0__/* .QueryKey.UpcomingEventsList */ .S.UpcomingEventsList, function() {
        return fetchUpcomingEventsList(apis);
    });
};


/***/ }),

/***/ 71680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fc": function() { return /* binding */ AuthorizationModalFormArea; },
/* harmony export */   "TR": function() { return /* binding */ ModalHeaderMobile; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "XL": function() { return /* binding */ AuthorizationModalInner; },
/* harmony export */   "Xy": function() { return /* binding */ GlobalErrorLayer; },
/* harmony export */   "Yb": function() { return /* binding */ FormContainer; },
/* harmony export */   "aN": function() { return /* binding */ Loader; },
/* harmony export */   "f6": function() { return /* binding */ FormTextBlock; },
/* harmony export */   "fM": function() { return /* binding */ CloseModalButton; },
/* harmony export */   "g8": function() { return /* binding */ ModalScrollableContent; },
/* harmony export */   "mX": function() { return /* binding */ AuthorizationModalFormPadding; },
/* harmony export */   "vb": function() { return /* binding */ ButtonsRow; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(87379);
/* harmony import */ var src_styles_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12258);
/* harmony import */ var src_components_common_SplitRow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5311);
/* harmony import */ var src_components_common_Loader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15572);
/* harmony import */ var src_components_ScrollableContent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53402);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73098);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(81041);
/* harmony import */ var src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71008);
/* harmony import */ var src_modules_modals_components_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47573);
/* harmony import */ var src_components_icons_AnimatedMenu__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79228);
/* harmony import */ var src_components_common_Button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(78296);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(17573);
/* harmony import */ var vendor_mods_media_breakpoints_fresnel_components_Media__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50696);
/* harmony import */ var src_components_common_typography_Form__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36163);
/* harmony import */ var src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(12732);
/* harmony import */ var src_modules_navigation_components_Header_HeaderLogo__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(89086);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(68251);
/* harmony import */ var src_components_common_FormScrollableContent__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14373);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 24px;\n  color: ",
        ";\n\n  strong {\n    font-weight: 700;\n  }\n\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        "px;\n  align-items: center;\n  ",
        " {\n    & > button:last-child {\n      grid-row: 1;\n      margin-bottom: 10px;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  grid-area: content;\n  max-height: 100%;\n  height: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  grid-area: content;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  grid-area: close;\n  align-self: flex-start;\n  justify-self: flex-end;\n  margin-right: calc(10vw - calc(var(--anti-scrollbar-padding) * 0.5));\n  margin-top: 9vh;\n  ",
        " {\n    margin-right: 0;\n    margin-left: calc(10vw - calc(var(--anti-scrollbar-padding) * 0.5));\n  }\n\n  ",
        " {\n    margin: auto !important;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: calc(var(--header-fixed-height) - 1rpx);\n  justify-content: space-between;\n  align-items: center;\n  grid-area: header;\n  color: ",
        ";\n  display: grid;\n  grid-template-areas: 'logo close';\n  background: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      grid-template-rows: minmax(0, 1fr) minmax(0px, max-content) minmax(0, 1fr);\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  grid-area: form;\n\n  display: grid;\n  overflow: hidden;\n  grid-template-columns: minmax(10vw, 1fr) calc(330px + 153px);\n  grid-template-rows: minmax(20px, 1fr) minmax(0px, max-content) minmax(\n      10vh,\n      1fr\n    );\n  padding-right: 20px;\n  margin-left: calc(var(--scrollbar-padding) * 0.5);\n  grid-template-areas:\n    '. .'\n    '. content'\n    '. .';\n\n  ",
        "\n  ",
        " {\n    padding-left: 20px;\n    padding-right: 0;\n  }\n  ",
        " {\n    overflow: visible;\n    padding: 20px;\n    padding-bottom: ",
        "px;\n    margin-left: 0;\n    margin-top: auto;\n    margin-bottom: auto;\n    grid-template-areas: 'content';\n    grid-template-columns: 1fr;\n    grid-template-rows: auto;\n  }\n  ",
        " {\n    @media (max-width: 1200px) {\n      --base-unit: min(100vw, 1600rpx) / 1050;\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  position: absolute;\n  top: 0;\n  left: calc(var(--scrollbar-padding) * -1);\n  right: 0;\n  bottom: 0;\n\n  grid-template-columns: 1fr 1fr;\n  grid-template-areas: 'form benefit';\n\n  // Safari 14 height bug fix\n  grid-template-rows: calc(var(--vh, 1vh) * 100);\n  align-content: stretch;\n\n  ",
        " {\n    position: relative;\n    height: 100%;\n    left: 0;\n    grid-template-areas: 'header' 'form' 'separator' 'benefit';\n\n    grid-template-columns: 1fr;\n\n    grid-template-rows: auto minmax(auto, 1fr) auto auto;\n\n    overflow: auto;\n\n    & ",
        " {\n      justify-content: center;\n    }\n\n    & ",
        " {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 10px;\n  form {\n    width: 350px;\n  }\n  ",
        " {\n    form {\n      width: 100%;\n    }\n    padding: 0px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}



















var FormTextBlock = styled_components__WEBPACK_IMPORTED_MODULE_17__["default"].div.withConfig({
    displayName: "internal__FormTextBlock",
    componentId: "sc-2c083a5-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, src_styles_designs__WEBPACK_IMPORTED_MODULE_6__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop);
var FormContainer = styled_components__WEBPACK_IMPORTED_MODULE_17__["default"].div.withConfig({
    displayName: "internal__FormContainer",
    componentId: "sc-2c083a5-1"
})(_templateObject1(), src_styles_designs__WEBPACK_IMPORTED_MODULE_6__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop);
var GlobalErrorLayer = styled_components__WEBPACK_IMPORTED_MODULE_17__["default"].div.withConfig({
    displayName: "internal__GlobalErrorLayer",
    componentId: "sc-2c083a5-2"
})(_templateObject2(), src_styles_common__WEBPACK_IMPORTED_MODULE_2__/* .layerCentered */ .aK);
var ButtonsRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_17__["default"])(src_components_common_SplitRow__WEBPACK_IMPORTED_MODULE_3__/* .SplitRow */ .R).withConfig({
    displayName: "internal__ButtonsRow",
    componentId: "sc-2c083a5-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.spacing.gap * 2;
}, src_styles_designs__WEBPACK_IMPORTED_MODULE_6__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop);
var Loader = src_components_common_Loader__WEBPACK_IMPORTED_MODULE_4__/* .HeroLoader */ .rK;
var Content = (0,styled_components__WEBPACK_IMPORTED_MODULE_17__["default"])(framer_motion__WEBPACK_IMPORTED_MODULE_18__/* .motion.div */ .E.div).withConfig({
    displayName: "internal__Content",
    componentId: "sc-2c083a5-4"
})(_templateObject4());
var ModalScrollableContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_17__["default"])(src_components_ScrollableContent__WEBPACK_IMPORTED_MODULE_5__/* .ScrollableContent */ .t).withConfig({
    displayName: "internal__ModalScrollableContent",
    componentId: "sc-2c083a5-5"
})(_templateObject5());
var CloseModalButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_17__["default"])(src_components_common_Button__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .zx).withConfig({
    displayName: "internal__CloseModalButton",
    componentId: "sc-2c083a5-6"
})(_templateObject6(), src_styles_theme__WEBPACK_IMPORTED_MODULE_15__/* .dirRTL */ .gX, src_styles_designs__WEBPACK_IMPORTED_MODULE_6__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop, function(param) {
    var theme = param.theme;
    return (0,polished__WEBPACK_IMPORTED_MODULE_19__/* .transparentize */ .DZ)(0.7, theme.palette.contrastToBackground);
});
var ModalHeaderMobileContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_17__["default"])(src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_7__/* .ConstraintContainer */ .a).withConfig({
    displayName: "internal__ModalHeaderMobileContainer",
    componentId: "sc-2c083a5-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.palette.accent;
}, function(param) {
    var theme = param.theme;
    return theme.palette.background;
});
var ModalHeaderMobile = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_media_breakpoints_fresnel_components_Media__WEBPACK_IMPORTED_MODULE_11__/* .Media */ .pU, {
        lessThan: "desktop",
        style: {
            gridArea: "header"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ModalHeaderMobileContainer, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_modules_navigation_components_Header_HeaderLogo__WEBPACK_IMPORTED_MODULE_14__/* .HeaderLogo */ .O, {
                    variant: "small"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_modules_modals_components_common__WEBPACK_IMPORTED_MODULE_8__/* .CloseModalWrapper */ .Bq, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CloseModalButton, {
                        kind: "text",
                        icon: src_components_icons_AnimatedMenu__WEBPACK_IMPORTED_MODULE_9__/* .AnimatedMenu */ .E,
                        iconProps: {
                            size: 28,
                            enabled: true
                        }
                    })
                })
            ]
        })
    });
};
var AuthorizationModalFormArea = styled_components__WEBPACK_IMPORTED_MODULE_17__["default"].div.withConfig({
    displayName: "internal__AuthorizationModalFormArea",
    componentId: "sc-2c083a5-8"
})(_templateObject9(), (0,src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_13__/* .casePathEmptyString */ .Q)("$hasOwnScrollableContent")((0,styled_components__WEBPACK_IMPORTED_MODULE_17__.css)(_templateObject8())), src_styles_theme__WEBPACK_IMPORTED_MODULE_15__/* .dirRTL */ .gX, src_styles_designs__WEBPACK_IMPORTED_MODULE_6__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop, function(param) {
    var theme = param.theme;
    return theme.spacing.gap * 2;
}, src_styles_designs__WEBPACK_IMPORTED_MODULE_6__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var AuthorizationModalInner = (0,styled_components__WEBPACK_IMPORTED_MODULE_17__["default"])(src_components_common_FormScrollableContent__WEBPACK_IMPORTED_MODULE_16__/* .FormScrollableContent */ .g).attrs({
    simplebar: false
}).withConfig({
    displayName: "internal__AuthorizationModalInner",
    componentId: "sc-2c083a5-9"
})(_templateObject10(), src_styles_designs__WEBPACK_IMPORTED_MODULE_6__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop, src_components_common_typography_Form__WEBPACK_IMPORTED_MODULE_12__/* .FormH2 */ .YV, src_components_common_typography_Form__WEBPACK_IMPORTED_MODULE_12__/* .FormH1 */ .N);
var AuthorizationModalFormPadding = (0,framer_motion__WEBPACK_IMPORTED_MODULE_18__/* .motion */ .E)(styled_components__WEBPACK_IMPORTED_MODULE_17__["default"].div.withConfig({
    displayName: "internal__AuthorizationModalFormPadding",
    componentId: "sc-2c083a5-10"
})(_templateObject11(), src_styles_designs__WEBPACK_IMPORTED_MODULE_6__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop));


/***/ }),

/***/ 23094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/react-t7e/lib/index.js
var lib = __webpack_require__(17739);
// EXTERNAL MODULE: ./src/components/common/ConstraintContainer.tsx
var ConstraintContainer = __webpack_require__(71008);
// EXTERNAL MODULE: ./src/styles/theme.ts + 3 modules
var theme = __webpack_require__(68251);
// EXTERNAL MODULE: ./src/styles/designs.ts
var designs = __webpack_require__(73098);
// EXTERNAL MODULE: ./src/components/common/typography/Header.tsx
var Header = __webpack_require__(29894);
;// CONCATENATED MODULE: ./src/modules/home/components/internal.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 150%;\n\n  ",
        " {\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 30px;\n  --left-usable-margin: 30px;\n\n  ",
        " {\n    margin-left: 120px;\n    --left-usable-margin: 120px;\n  }\n\n  ",
        " {\n    margin-left: 0;\n    margin-right: 30px;\n\n    ",
        " {\n      margin-left: 0;\n      margin-right: 120px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: -30px;\n\n  ",
        " {\n    margin-left: -40px;\n  }\n  ",
        " {\n    margin-left: 0;\n    margin-right: -30px;\n\n    ",
        " {\n      margin-left: 0;\n      margin-right: -40px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var HomeSection = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).attrs({
    as: "section"
}).withConfig({
    displayName: "internal__HomeSection",
    componentId: "sc-35e58603-0"
})(_templateObject(), (0,theme/* fromTheme */.HW)(function(theme) {
    return theme.text.palette.primary;
}), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var HomeSectionPaddedContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "internal__HomeSectionPaddedContent",
    componentId: "sc-35e58603-1"
})(_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, theme/* dirRTL */.gX, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var HomeSectionHeaderPrimary = (0,styled_components_browser_esm["default"])(Header.H1).attrs({
    as: "h2"
}).withConfig({
    displayName: "internal__HomeSectionHeaderPrimary",
    componentId: "sc-35e58603-2"
})(_templateObject2(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, theme/* dirRTL */.gX, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var HomeSectionHeaderSecondary = Header.H3;

// EXTERNAL MODULE: ./vendor/mods/markdown/components/Markdown.tsx
var Markdown = __webpack_require__(15201);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./src/modules/videos/components/VideoSummary.tsx + 1 modules
var VideoSummary = __webpack_require__(45522);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 109 modules
var motion = __webpack_require__(81041);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 2 modules
var AnimatePresence = __webpack_require__(14332);
// EXTERNAL MODULE: ./src/components/common/DirectusImage.tsx
var DirectusImage = __webpack_require__(52520);
// EXTERNAL MODULE: ./src/components/common/Skeleton.tsx
var Skeleton = __webpack_require__(47536);
// EXTERNAL MODULE: ./src/components/player/index.tsx + 30 modules
var components_player = __webpack_require__(44732);
;// CONCATENATED MODULE: ./src/modules/videos/components/VideoSlide.tsx

function VideoSlide_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 941px;\n  height: 389px;\n  position: relative;\n\n  ",
        " {\n    width: 320px;\n  }\n"
    ]);
    VideoSlide_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VideoSlide_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n"
    ]);
    VideoSlide_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function VideoSlide_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 100%;\n  width: 100%;\n  background-color: ",
        ";\n\n  display: grid;\n  grid-template-areas: 'player' 'summary';\n  grid-template-columns: 100%;\n  grid-template-rows: 180px 1fr;\n\n  ",
        " {\n    grid-template-areas: 'summary player';\n    grid-template-columns: 249px 1fr;\n    grid-template-rows: 100%;\n  }\n"
    ]);
    VideoSlide_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: summary;\n  width: 100%;\n  height: 100%;\n  padding: 15px 14px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  ",
        " {\n    padding: 22px 16px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: player;\n  min-width: 0;\n  min-height: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}










var Slide = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VideoSlide__Slide",
    componentId: "sc-4770895f-0"
})(VideoSlide_templateObject(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var Thumbnail = (0,styled_components_browser_esm["default"])(DirectusImage/* DirectusImage */.q).withConfig({
    displayName: "VideoSlide__Thumbnail",
    componentId: "sc-4770895f-1"
})(VideoSlide_templateObject1());
var VideoPlayerContainer = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "VideoSlide__VideoPlayerContainer",
    componentId: "sc-4770895f-2"
})(VideoSlide_templateObject2(), function(props) {
    return props.theme.palette.background;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Summary = (0,styled_components_browser_esm["default"])(VideoSummary/* VideoSummary */.C).withConfig({
    displayName: "VideoSlide__Summary",
    componentId: "sc-4770895f-3"
})(_templateObject3(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Player = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VideoSlide__Player",
    componentId: "sc-4770895f-4"
})(_templateObject4());
var thumbnailContainerVariants = {
    in: {
        opacity: 1
    },
    out: {
        opacity: 0,
        transition: {
            delay: 1
        }
    }
};
var playerContainerVariants = {
    in: {
        opacity: 1
    },
    out: {
        opacity: 0
    }
};
var VideoSlide = /*#__PURE__*/ (0,react.memo)(function(param) {
    var active = param.active, video = param.video;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm.ThemeProvider, {
        theme: theme/* redTheme */.MN,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                initial: false,
                exitBeforeEnter: false,
                children: video ? active ? /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                    initial: "out",
                    animate: "in",
                    exit: "out",
                    transition: {
                        delay: 0.5
                    },
                    variants: playerContainerVariants,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoPlayerContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Summary, {
                                video: video
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Player, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_player/* NeauviaPlayerLayer */.jT, {
                                    video: video,
                                    autoPlay: false
                                })
                            })
                        ]
                    })
                }, "VideoPlayerContainer") : /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                    initial: "out",
                    animate: "in",
                    exit: "out",
                    variants: thumbnailContainerVariants,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoPlayerContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Summary, {
                                video: video
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Player, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumbnail, {
                                    src: video.thumbnail.id,
                                    layout: "fill",
                                    sizes: "(min-width: 1000px) 80vw, 90vw"
                                })
                            })
                        ]
                    })
                }, "ThumbnailContainer") : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                    fill: true
                })
            })
        })
    });
});
VideoSlide.displayName = "VideoSlide";

// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 12 modules
var swiper_react = __webpack_require__(72873);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 92 modules
var swiper_esm = __webpack_require__(89979);
// EXTERNAL MODULE: ./src/hooks/dev/useFastRefreshFixer.tsx
var useFastRefreshFixer = __webpack_require__(78162);
// EXTERNAL MODULE: ./src/components/common/ResponsiveUnit.tsx
var ResponsiveUnit = __webpack_require__(47631);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@summer/jst-react-icon/lib/index.js
var jst_react_icon_lib = __webpack_require__(55537);
;// CONCATENATED MODULE: ./src/components/icons/ArrowLeft.tsx





var ArrowLeft = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jst_react_icon_lib/* IconBox */.zb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 43 32",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M15.875 31L1 16M1 16L15.875 1M1 16H43",
            stroke: "#828282"
        })
    }));
};
/* harmony default export */ var icons_ArrowLeft = (ArrowLeft);

;// CONCATENATED MODULE: ./src/components/icons/ArrowRight.tsx





var ArrowRight = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jst_react_icon_lib/* IconBox */.zb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 43 32",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M27.125 1L42 16M42 16L27.125 31M42 16H0",
            stroke: "#828282"
        })
    }));
};
/* harmony default export */ var icons_ArrowRight = (ArrowRight);

// EXTERNAL MODULE: ./src/components/common/Button/index.tsx + 8 modules
var Button = __webpack_require__(78296);
// EXTERNAL MODULE: ./src/hooks/useIsRTL.ts + 1 modules
var useIsRTL = __webpack_require__(36311);
// EXTERNAL MODULE: ./src/utils/coerceArray.ts
var coerceArray = __webpack_require__(13762);
;// CONCATENATED MODULE: ./src/components/common/HeroSlider.tsx

function HeroSlider_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  position: relative;\n"
    ]);
    HeroSlider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HeroSlider_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: visible;\n  width: 941px !important;\n\n  ",
        " {\n    width: 320px !important;\n  }\n\n  .swiper-slide {\n    opacity: 0;\n  }\n\n  ",
        " {\n    direction: ltr;\n    .swiper-slide > * {\n      direction: rtl;\n    }\n  }\n"
    ]);
    HeroSlider_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HeroSlider_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  position: absolute;\n  width: 43px;\n  left: 40px;\n  top: 50%;\n  transform: translate(0%, -50%);\n  transition: opacity 0.3s, transform 0.3s;\n\n  button[disabled] & {\n    opacity: 0;\n  }\n\n  button:active:not([disabled]) & {\n    transform: translate(0%, -50%) scale(0.8);\n  }\n"
    ]);
    HeroSlider_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HeroSlider_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  position: absolute;\n  width: 43px;\n  right: 40px;\n  top: 50%;\n  transform: translate(0%, -50%);\n  transition: opacity 0.3s, transform 0.3s;\n\n  button[disabled] & {\n    opacity: 0;\n  }\n\n  button:active:not([disabled]) & {\n    transform: translate(0%, -50%) scale(0.8);\n  }\n"
    ]);
    HeroSlider_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HeroSlider_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 200px;\n  height: 100%;\n  left: 0;\n  top: 0;\n  z-index: 2;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    HeroSlider_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 200px;\n  height: 100%;\n  right: 0;\n  top: 0;\n  z-index: 2;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}














var Overflow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HeroSlider__Overflow",
    componentId: "sc-c300daaa-0"
})(HeroSlider_templateObject());
var CenteredSwiper = (0,styled_components_browser_esm["default"])(swiper_react/* Swiper */.t).withConfig({
    displayName: "HeroSlider__CenteredSwiper",
    componentId: "sc-c300daaa-1"
})(HeroSlider_templateObject1(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, theme/* dirRTL */.gX);
var BackArrow = (0,styled_components_browser_esm["default"])(icons_ArrowLeft).withConfig({
    displayName: "HeroSlider__BackArrow",
    componentId: "sc-c300daaa-2"
})(HeroSlider_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.palette.gray3;
});
var ForwardArrow = (0,styled_components_browser_esm["default"])(icons_ArrowRight).withConfig({
    displayName: "HeroSlider__ForwardArrow",
    componentId: "sc-c300daaa-3"
})(HeroSlider_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.palette.gray3;
});
var BackArrowButton = (0,styled_components_browser_esm["default"])(Button/* CleanButton */.ux).withConfig({
    displayName: "HeroSlider__BackArrowButton",
    componentId: "sc-c300daaa-4"
})(HeroSlider_templateObject4(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var ForwardArrowButton = (0,styled_components_browser_esm["default"])(Button/* CleanButton */.ux).withConfig({
    displayName: "HeroSlider__ForwardArrowButton",
    componentId: "sc-c300daaa-5"
})(_templateObject5(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var HeroSlider = function(param) {
    var children = param.children, _additionalSlides = param.additionalSlides, additionalSlides = _additionalSlides === void 0 ? 2 : _additionalSlides, _initialSlide = param.initialSlide, initialSlide = _initialSlide === void 0 ? 0 : _initialSlide, onSlideChange = param.onSlideChange, activeSlide = param.activeSlide;
    var key = (0,useFastRefreshFixer/* useFastRefreshFixer */.P)();
    var isRTL = (0,useIsRTL/* useIsRTL */.S)();
    var ref = (0,react.useState)(initialSlide), currentIndex = ref[0], setCurrentIndex = ref[1];
    var swiperRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (activeSlide !== undefined) {
            if (swiperRef.current) {
                if (swiperRef.current.activeIndex !== activeSlide) {
                    swiperRef.current.slideTo(activeSlide);
                }
            }
        }
    }, [
        activeSlide
    ]);
    var modules = (0,react.useMemo)(function() {
        return [
            swiper_esm/* EffectCreative */.gI
        ];
    }, []);
    var onSlidePrev = (0,react.useCallback)(function() {
        var ref;
        return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slidePrev();
    }, []);
    var onSlideNext = (0,react.useCallback)(function() {
        var ref;
        return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slideNext();
    }, []);
    var onSwiper = (0,react.useCallback)(function(swiper) {
        swiperRef.current = swiper;
        var ref;
        setCurrentIndex((ref = swiper === null || swiper === void 0 ? void 0 : swiper.activeIndex) !== null && ref !== void 0 ? ref : initialSlide);
    }, [
        setCurrentIndex,
        initialSlide
    ]);
    var onSlideChangeCallback = (0,react.useCallback)(function() {
        if (swiperRef.current && swiperRef.current.activeIndex !== undefined) {
            setCurrentIndex(swiperRef.current.activeIndex);
            onSlideChange === null || onSlideChange === void 0 ? void 0 : onSlideChange(swiperRef.current.activeIndex);
        }
    }, [
        setCurrentIndex,
        onSlideChange
    ]);
    var isControlled = activeSlide !== undefined;
    if (children == null) {
        return null;
    }
    var slides = (0,coerceArray/* coerceArray */.E)(children);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveUnit/* ResponsiveUnit */.D, {
        children: function(px) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Overflow, {
                children: [
                    !isControlled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackArrowButton, {
                                disabled: currentIndex === 0,
                                onClick: onSlidePrev,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackArrow, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardArrowButton, {
                                disabled: currentIndex === slides.length - 1,
                                onClick: onSlideNext,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardArrow, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CenteredSwiper, {
                        allowTouchMove: !isControlled,
                        modules: modules,
                        centeredSlides: true,
                        initialSlide: activeSlide !== null && activeSlide !== void 0 ? activeSlide : currentIndex,
                        slidesPerView: 1,
                        effect: "creative",
                        onSwiper: onSwiper,
                        onSlideChange: onSlideChangeCallback,
                        noSwipingClass: "swiper-restrict-swipe",
                        creativeEffect: {
                            shadowPerProgress: true,
                            limitProgress: additionalSlides,
                            prev: {
                                shadow: true,
                                translate: [
                                    -150 * px,
                                    0,
                                    -220 * px
                                ]
                            },
                            next: {
                                shadow: true,
                                translate: [
                                    150 * px,
                                    0,
                                    -220 * px
                                ]
                            }
                        },
                        children: slides.map(function(_, i) {
                            return i <= currentIndex + additionalSlides + 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                                children: currentIndex - additionalSlides - 1 <= i && i <= currentIndex + additionalSlides + 1 ? /*#__PURE__*/ (0,react.cloneElement)(slides[i], {
                                    active: i === currentIndex
                                }) : null
                            }, i) : null;
                        })
                    }, "".concat(isRTL).concat(key).concat(px).concat(isControlled ? "c" : "u"))
                ]
            });
        }
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/hooks/useAPIs.ts
var useAPIs = __webpack_require__(53100);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/models/query.ts
var query = __webpack_require__(19162);
// EXTERNAL MODULE: ./src/modules/videos/graphql/videos-shortcodes.fragment.ts
var videos_shortcodes_fragment = __webpack_require__(67561);
// EXTERNAL MODULE: ./src/utils/gql/query.ts
var gql_query = __webpack_require__(72493);
;// CONCATENATED MODULE: ./src/modules/home/graphql/recommended-videos.query.ts

function recommended_videos_query_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  query RecommendedVideosQuery($filter: videos_filter) {\n    videos(filter: $filter) {\n      id\n      slug\n      thumbnail {\n        id\n      }\n      bodyParts {\n        bodyParts_id {\n          slug\n        }\n      }\n      subjects {\n        subjects_id {\n          slug\n        }\n      }\n      tags {\n        tags_id {\n          id\n          translations {\n            name\n            languages_code {\n              code\n            }\n          }\n        }\n      }\n      shortcodes {\n        ...shortcodes\n      }\n      disclaimer\n      source {\n        id\n        url\n        format\n        duration\n      }\n      specializations {\n        specializations_id {\n          slug\n        }\n      }\n      audioLanguages {\n        languages_code {\n          code\n        }\n      }\n      subtitleLanguages {\n        languages_code {\n          code\n        }\n      }\n      translations {\n        description\n        excerpt\n        name\n        languages_code {\n          code\n        }\n      }\n      speakers {\n        people_id {\n          id\n          avatar {\n            id\n          }\n          name\n          translations {\n            degree\n            title\n            languages_code {\n              code\n            }\n          }\n          country {\n            translations {\n              languages_code {\n                code\n              }\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    recommended_videos_query_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var recommendedVideosGqlQuery = (0,gql_query/* gql */.Ps)(recommended_videos_query_templateObject(), videos_shortcodes_fragment/* shortcodesGqlFragment */.U);

// EXTERNAL MODULE: ./src/modules/user/hooks/useUserQuery.ts
var useUserQuery = __webpack_require__(44320);
;// CONCATENATED MODULE: ./src/modules/home/hooks/useRecommendedVideosQuery.ts








var fetchRecommendedVideos = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(apis, params) {
        var directus, recommendedVideoIds;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        apis.directus()
                    ];
                case 1:
                    directus = _state.sent();
                    return [
                        4,
                        directus.api.recommended.videos(params)
                    ];
                case 2:
                    recommendedVideoIds = _state.sent();
                    return [
                        2,
                        directus.query(recommendedVideosGqlQuery, {
                            filter: {
                                id: {
                                    _in: recommendedVideoIds
                                }
                            }
                        }).then(function(a) {
                            return a.videos.filter(function(v) {
                                return v;
                            });
                        })
                    ];
            }
        });
    });
    return function fetchRecommendedVideos(apis, params) {
        return _ref.apply(this, arguments);
    };
}();
var recommendedVideosQuery = function(apis, identity) {
    var params = identity == null ? {
        public: true
    } : {
        specialization: identity.traits.specialization,
        languages: identity.traits.languages,
        country: identity.traits.country
    };
    return {
        queryKey: (0,_to_consumable_array/* default */.Z)(query/* QueryKey.RecommendedVideos */.S.RecommendedVideos).concat([
            params
        ]),
        queryFn: function() {
            return fetchRecommendedVideos(apis, params);
        }
    };
};
var useRecommendedVideosQuery = function() {
    var apis = (0,useAPIs/* useAPIs */.V)();
    var ref = (0,useUserQuery/* useUserQuery */.b)(), session = ref.data;
    return (0,es.useQuery)(recommendedVideosQuery(apis, session === null || session === void 0 ? void 0 : session.identity));
};

// EXTERNAL MODULE: ./node_modules/lodash/range.js
var range = __webpack_require__(96026);
var range_default = /*#__PURE__*/__webpack_require__.n(range);
;// CONCATENATED MODULE: ./src/modules/home/components/HomeFeaturedSection/RecommendedVideosSlider.tsx







var RecommendedVideosSlider = /*#__PURE__*/ (0,react.memo)(function RecommendedVideosSlider() {
    var ref = useRecommendedVideosQuery(), videos = ref.data, isLoading = ref.isLoading;
    var sortedVideos = (0,react.useMemo)(function() {
        if (videos) {
            var middle = videos[0];
            var leftSide = videos.filter(function(_, i) {
                return i % 2 !== 0;
            }).reverse();
            var rightSide = videos.filter(function(_, i) {
                return i !== 0 && i % 2 === 0;
            });
            return (0,_to_consumable_array/* default */.Z)(leftSide).concat([
                middle
            ], (0,_to_consumable_array/* default */.Z)(rightSide));
        }
    }, [
        videos
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSlider, {
        initialSlide: Math.floor(sortedVideos ? sortedVideos.length / 2 : 2),
        children: isLoading ? range_default()(5).map(function(num) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoSlide, {
                video: null
            }, num);
        }) : sortedVideos === null || sortedVideos === void 0 ? void 0 : sortedVideos.map(function(a) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoSlide, {
                video: a
            }, a.id);
        })
    });
});

// EXTERNAL MODULE: ./src/utils/WithSilentErrorBoundary.tsx
var WithSilentErrorBoundary = __webpack_require__(45402);
;// CONCATENATED MODULE: ./src/modules/home/components/HomeFeaturedSection/index.tsx

function HomeFeaturedSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 70px;\n\n  ",
        " {\n    margin-top: 100px;\n  }\n"
    ]);
    HomeFeaturedSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HomeFeaturedSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    margin-bottom: 36px;\n    br {\n      display: none;\n    }\n  }\n"
    ]);
    HomeFeaturedSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HomeFeaturedSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    HomeFeaturedSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var Section = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).attrs({
    as: "section"
}).withConfig({
    displayName: "HomeFeaturedSection__Section",
    componentId: "sc-ca84ef8e-0"
})(HomeFeaturedSection_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var HomeFeaturedSection_Header = (0,styled_components_browser_esm["default"])(HomeSectionHeaderPrimary).attrs({
    as: "h2"
}).withConfig({
    displayName: "HomeFeaturedSection__Header",
    componentId: "sc-ca84ef8e-1"
})(HomeFeaturedSection_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var SliderContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeFeaturedSection__SliderContainer",
    componentId: "sc-ca84ef8e-2"
})(HomeFeaturedSection_templateObject2(), ConstraintContainer/* overflowConstraintContainer */.as);
var HomeFeaturedSection = (0,WithSilentErrorBoundary/* withSilentErrorBoundary */.o)(function() {
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeSectionPaddedContent, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeFeaturedSection_Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        children: _("Specially for you")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedVideosSlider, {})
            })
        ]
    });
});

// EXTERNAL MODULE: ./src/components/TrackedLink.tsx
var TrackedLink = __webpack_require__(79017);
// EXTERNAL MODULE: ./src/modules/modals/components/Authorization/internal.tsx
var internal = __webpack_require__(71680);
// EXTERNAL MODULE: ./src/components/common/LoaderTransition.tsx
var LoaderTransition = __webpack_require__(8183);
// EXTERNAL MODULE: ./src/hooks/directus/useTranslateItem.ts
var useTranslateItem = __webpack_require__(70057);
// EXTERNAL MODULE: ./src/services/route.ts + 1 modules
var route = __webpack_require__(38325);
// EXTERNAL MODULE: ./src/modules/home/components/HomeBusinessCasesSection/Showcase.tsx
var Showcase = __webpack_require__(45499);
// EXTERNAL MODULE: ./src/modules/home/hooks/useBusinessCasesVideosQuery.ts + 1 modules
var useBusinessCasesVideosQuery = __webpack_require__(79429);
;// CONCATENATED MODULE: ./src/modules/home/components/HomeBusinessCasesSection/BusinessCasesShowcase.tsx



function BusinessCasesShowcase_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  grid-area: showcase;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  & > div {\n    width: 100%;\n  }\n"
    ]);
    BusinessCasesShowcase_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BusinessCasesShowcase_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-column-gap: 5px;\n  padding: 30px 0 0 0;\n\n  ",
        " {\n    grid-column-gap: 10px;\n    margin-left: 50px;\n  }\n"
    ]);
    BusinessCasesShowcase_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BusinessCasesShowcase__Wrapper",
    componentId: "sc-14713925-0"
})(BusinessCasesShowcase_templateObject());
var Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BusinessCasesShowcase__Container",
    componentId: "sc-14713925-1"
})(BusinessCasesShowcase_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var BusinessCasesShowcase = function(props) {
    var translateItem = (0,useTranslateItem/* useTranslateItem */.L)();
    var ref = (0,useBusinessCasesVideosQuery/* useBusinessCasesVideosQuery */.i)(3), data = ref.data, isLoading = ref.isLoading;
    var preparedVideos = (0,react.useMemo)(function() {
        var videos = data === null || data === void 0 ? void 0 : data.map(function(video) {
            var speaker = translateItem(video.speakers[0].people_id);
            return {
                speaker: speaker,
                link: route/* route.video */.BC.video(video).page()
            };
        });
        return videos || [];
    }, [
        data,
        translateItem
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderTransition/* LoaderTransition */.t, {
            Loader: internal/* Loader */.aN,
            animateAlways: true,
            children: !isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                children: preparedVideos.map(function(param) {
                    var link = param.link, speaker = param.speaker;
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
                        href: link,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Showcase/* Showcase */.$m, {
                            image: (ref = speaker.portrait) === null || ref === void 0 ? void 0 : ref.id,
                            title: speaker.name,
                            subtitle: [
                                speaker.degree,
                                speaker.title
                            ].filter(function(el) {
                                return el;
                            }).join(", ")
                        })
                    }, link);
                })
            })) : null
        })
    });
};

;// CONCATENATED MODULE: ./src/modules/home/components/HomeBusinessCasesSection/index.tsx

function HomeBusinessCasesSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 70px;\n  display: grid;\n  grid-template-areas: 'content' 'showcase' 'cta';\n  grid-row-gap: 30px;\n  grid-template-columns: 100%;\n  overflow: hidden;\n\n  ",
        " {\n    margin-top: 120px;\n    grid-template-areas: 'content showcase' 'cta showcase';\n    grid-template-columns: 2fr 3fr;\n    grid-row-gap: 30px;\n  }\n"
    ]);
    HomeBusinessCasesSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HomeBusinessCasesSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: content;\n  align-self: flex-end;\n  ",
        " {\n    max-width: 320px;\n  }\n"
    ]);
    HomeBusinessCasesSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HomeBusinessCasesSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: cta;\n\n  ",
        " {\n    margin-left: 0;\n    text-align: center;\n  }\n"
    ]);
    HomeBusinessCasesSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HomeBusinessCasesSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: showcase;\n  ",
        ";\n\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    HomeBusinessCasesSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












var HomeBusinessCasesSection_Section = (0,styled_components_browser_esm["default"])(HomeSection).withConfig({
    displayName: "HomeBusinessCasesSection__Section",
    componentId: "sc-1d26992c-0"
})(HomeBusinessCasesSection_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ContentContainer = (0,styled_components_browser_esm["default"])(HomeSectionPaddedContent).withConfig({
    displayName: "HomeBusinessCasesSection__ContentContainer",
    componentId: "sc-1d26992c-1"
})(HomeBusinessCasesSection_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var CTAContainer = (0,styled_components_browser_esm["default"])(HomeSectionPaddedContent).withConfig({
    displayName: "HomeBusinessCasesSection__CTAContainer",
    componentId: "sc-1d26992c-2"
})(HomeBusinessCasesSection_templateObject2(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var StyledBusinessCasesShowcase = (0,styled_components_browser_esm["default"])(BusinessCasesShowcase).withConfig({
    displayName: "HomeBusinessCasesSection__StyledBusinessCasesShowcase",
    componentId: "sc-1d26992c-3"
})(HomeBusinessCasesSection_templateObject3(), ConstraintContainer/* overflowConstraintContainerMobile */.LK, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var HomeBusinessCasesSection = (0,WithSilentErrorBoundary/* withSilentErrorBoundary */.o)(function() {
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomeBusinessCasesSection_Section, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeSectionHeaderSecondary, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: _("Get the knowledge")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeSectionHeaderPrimary, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: _("EXPERTS TALKS")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: _("Interviews with the best surgeons and specialists in the Aesthetic industry")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
                    href: route/* route.search */.BC.search({
                        subject: "experts-talks"
                    }).videos(),
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                        as: "a",
                        children: _("See all interviews")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBusinessCasesShowcase, {})
        ]
    });
});

// EXTERNAL MODULE: ./src/components/common/FaceComponent/index.tsx + 1 modules
var FaceComponent = __webpack_require__(41267);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./src/components/common/FormikAutoSubmit.tsx + 1 modules
var FormikAutoSubmit = __webpack_require__(30145);
;// CONCATENATED MODULE: ./src/modules/home/graphql/learnbycase-videos.query.ts

function learnbycase_videos_query_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  query LearnByCaseVideosQuery($filter: videos_filter) {\n    videos(filter: $filter, limit: 3, sort: ["-date_created"]) {\n      slug\n      thumbnail {\n        id\n      }\n      translations {\n        name\n        languages_code {\n          code\n        }\n      }\n      disclaimer\n      source {\n        id\n        url\n        format\n        duration\n      }\n      bodyParts {\n        bodyParts_id {\n          slug\n        }\n      }\n      subjects {\n        subjects_id {\n          slug\n        }\n      }\n      speakers {\n        people_id {\n          id\n          avatar {\n            id\n          }\n        }\n      }\n    }\n  }\n'
    ]);
    learnbycase_videos_query_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var learnByCaseVideosGqlQuery = (0,gql_query/* gql */.Ps)(learnbycase_videos_query_templateObject());

;// CONCATENATED MODULE: ./src/modules/home/hooks/useLearnByCaseVideosQuery.ts








var fetchLearnByCaseVideos = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(apis) {
        var bodyParts, directus, videos;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bodyParts = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : [];
                    return [
                        4,
                        apis.directus()
                    ];
                case 1:
                    directus = _state.sent();
                    return [
                        4,
                        directus.query(learnByCaseVideosGqlQuery, {
                            filter: (0,_object_spread/* default */.Z)({
                                showcase: {
                                    _eq: true
                                }
                            }, bodyParts.length > 0 ? {
                                bodyParts: {
                                    bodyParts_id: {
                                        slug: {
                                            _in: bodyParts
                                        }
                                    }
                                }
                            } : {})
                        }).then(function(a) {
                            return a.videos.filter(function(v) {
                                return v;
                            });
                        })
                    ];
                case 2:
                    videos = _state.sent();
                    return [
                        2,
                        {
                            count: videos.length,
                            videos: videos
                        }
                    ];
            }
        });
    });
    return function fetchLearnByCaseVideos(apis) {
        return _ref.apply(this, arguments);
    };
}();
var useLearnByCaseVideosQuery = function() {
    var bodyParts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var apis = (0,useAPIs/* useAPIs */.V)();
    return (0,es.useQuery)((0,_to_consumable_array/* default */.Z)(query/* QueryKey.LearnByCaseVideos */.S.LearnByCaseVideos).concat((0,_to_consumable_array/* default */.Z)(bodyParts)), function() {
        return fetchLearnByCaseVideos(apis, bodyParts);
    });
};

// EXTERNAL MODULE: ./src/styles/common.ts
var common = __webpack_require__(12258);
// EXTERNAL MODULE: ./src/modules/user/components/Avatar.tsx + 2 modules
var Avatar = __webpack_require__(43029);
// EXTERNAL MODULE: ./src/components/icons/Lock.tsx
var Lock = __webpack_require__(94562);
// EXTERNAL MODULE: ./src/modules/user/utils/permissions.ts
var permissions = __webpack_require__(96117);
;// CONCATENATED MODULE: ./src/modules/home/components/HomeLearnByCaseSection/VideoItemPreview.tsx

function VideoItemPreview_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: title;\n\n  color: ",
        ";\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 130%;\n  transition: 100ms color;\n\n  ",
        ";\n"
    ]);
    VideoItemPreview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VideoItemPreview_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-areas: 'thumbnail title' 'thumbnail speakers';\n  grid-template-columns: 80px 1fr;\n  grid-template-rows: 1fr 30px;\n  grid-column-gap: 14px;\n  grid-row-gap: 8px;\n\n  &:hover {\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    VideoItemPreview_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function VideoItemPreview_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: thumbnail;\n  position: relative;\n\n  img {\n    object-fit: cover;\n  }\n"
    ]);
    VideoItemPreview_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function VideoItemPreview_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  top: 50%;\n  left: 50%;\n\n  ",
        " {\n    transform: translate(-50%, -50%);\n    color: white;\n  }\n\n  ",
        " {\n    width: 12px;\n    height: 12px;\n    top: 0;\n    left: -18px;\n  }\n  ",
        " {\n    left: auto;\n    right: 50%;\n    ",
        " {\n      transform: translate(50%, -50%);\n    }\n    ",
        " {\n      right: -18px;\n    }\n  }\n"
    ]);
    VideoItemPreview_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function VideoItemPreview_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: speakers;\n  display: flex;\n"
    ]);
    VideoItemPreview_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function VideoItemPreview_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 30px;\n  width: 30px;\n\n  &:not(:first-child) {\n    margin-left: -6px;\n  }\n"
    ]);
    VideoItemPreview_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}














var Title = styled_components_browser_esm["default"].span.withConfig({
    displayName: "VideoItemPreview__Title",
    componentId: "sc-92f00d4c-0"
})(VideoItemPreview_templateObject(), (0,theme/* fromTheme */.HW)(function(theme) {
    return theme.text.palette.secondary;
}), (0,common/* lineClamp */.Sf)(3));
var VideoItemPreview_Container = (0,styled_components_browser_esm["default"])(Button/* CleanButton */.ux).withConfig({
    displayName: "VideoItemPreview__Container",
    componentId: "sc-92f00d4c-1"
})(VideoItemPreview_templateObject1(), Title, (0,theme/* fromTheme */.HW)(function(theme) {
    return theme.text.palette.accent;
}));
var VideoItemPreview_Thumbnail = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VideoItemPreview__Thumbnail",
    componentId: "sc-92f00d4c-2"
})(VideoItemPreview_templateObject2());
var StyledLock = (0,styled_components_browser_esm["default"])(Lock/* Lock */.H).withConfig({
    displayName: "VideoItemPreview__StyledLock",
    componentId: "sc-92f00d4c-3"
})(VideoItemPreview_templateObject3(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, theme/* dirRTL */.gX, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Speakers = styled_components_browser_esm["default"].span.withConfig({
    displayName: "VideoItemPreview__Speakers",
    componentId: "sc-92f00d4c-4"
})(VideoItemPreview_templateObject4());
var StyledAvatar = (0,styled_components_browser_esm["default"])(Avatar/* Avatar */.qE).withConfig({
    displayName: "VideoItemPreview__StyledAvatar",
    componentId: "sc-92f00d4c-5"
})(VideoItemPreview_templateObject5());
var VideoItemPreview = function(param) {
    var video = param.video;
    var ref, ref1;
    var translatedVideo = (0,useTranslateItem/* useTranslateItem */.L)(video);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
        href: route/* route.video */.BC.video(video).page(),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoItemPreview_Container, {
            as: "a",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoItemPreview_Thumbnail, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectusImage/* DirectusImage */.q, {
                            src: (ref = video.thumbnail) === null || ref === void 0 ? void 0 : ref.id,
                            width: 100,
                            height: 60,
                            quality: 85
                        }),
                        !(0,permissions/* canUserAccessItem */.k)(video) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLock, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    children: translatedVideo.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Speakers, {
                    children: (ref1 = video.speakers) === null || ref1 === void 0 ? void 0 : ref1.map(function(a) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(StyledAvatar, {
                            src: (ref = a.people_id.avatar) === null || ref === void 0 ? void 0 : ref.id
                        }, a.people_id.id);
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/common/typography/Text.tsx
var Text = __webpack_require__(51306);
;// CONCATENATED MODULE: ./src/modules/home/components/HomeLearnByCaseSection/index.tsx

function HomeLearnByCaseSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin-top: 120px;\n  display: grid;\n  grid-template-areas: 'content' 'showcase' 'videos' 'cta';\n  grid-row-gap: 30px;\n  grid-template-columns: 100%;\n\n  ",
        " {\n    margin-top: 120px;\n    grid-template-areas: 'content showcase videos' 'cta showcase videos';\n    grid-template-columns: 4fr auto 3fr;\n    grid-row-gap: 30px;\n  }\n"
    ]);
    HomeLearnByCaseSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HomeLearnByCaseSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  z-index: 2;\n  grid-area: cta;\n\n  ",
        " {\n    margin: 0 auto !important;\n    text-align: center;\n  }\n"
    ]);
    HomeLearnByCaseSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HomeLearnByCaseSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    margin-top: 30px;\n  }\n"
    ]);
    HomeLearnByCaseSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HomeLearnByCaseSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  z-index: 2;\n  grid-area: content;\n  align-self: flex-end;\n"
    ]);
    HomeLearnByCaseSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HomeLearnByCaseSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: showcase;\n  padding: 0 10px;\n\n  ",
        " {\n    width: 535.44px;\n  }\n  ",
        " {\n    position: relative;\n  }\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1;\n    background: linear-gradient(\n      360deg,\n      #ebebeb 0%,\n      rgba(242, 242, 242, 0) 77.19%\n    );\n  }\n  & > div {\n    position: relative;\n    z-index: 2;\n  }\n"
    ]);
    HomeLearnByCaseSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HomeLearnByCaseSection_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  z-index: 2;\n  grid-area: videos;\n  align-self: center;\n  ",
        " {\n    ",
        " {\n      padding-right: 50px;\n    }\n  }\n"
    ]);
    HomeLearnByCaseSection_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 21px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 10px;\n  vertical-align: baseline;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




















var HomeLearnByCaseSection_Section = (0,styled_components_browser_esm["default"])(HomeSection).withConfig({
    displayName: "HomeLearnByCaseSection__Section",
    componentId: "sc-40df0808-0"
})(HomeLearnByCaseSection_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var HomeLearnByCaseSection_CTAContainer = (0,styled_components_browser_esm["default"])(HomeSectionPaddedContent).withConfig({
    displayName: "HomeLearnByCaseSection__CTAContainer",
    componentId: "sc-40df0808-1"
})(HomeLearnByCaseSection_templateObject1(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var CTA = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "HomeLearnByCaseSection__CTA",
    componentId: "sc-40df0808-2"
})(HomeLearnByCaseSection_templateObject2(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var HomeLearnByCaseSection_ContentContainer = (0,styled_components_browser_esm["default"])(HomeSectionPaddedContent).withConfig({
    displayName: "HomeLearnByCaseSection__ContentContainer",
    componentId: "sc-40df0808-3"
})(HomeLearnByCaseSection_templateObject3());
var LearnByCaseFaceComponent = (0,styled_components_browser_esm["default"])(FaceComponent/* FaceComponentFormik */["in"]).withConfig({
    displayName: "HomeLearnByCaseSection__LearnByCaseFaceComponent",
    componentId: "sc-40df0808-4"
})(HomeLearnByCaseSection_templateObject4(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var VideosArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeLearnByCaseSection__VideosArea",
    componentId: "sc-40df0808-5"
})(HomeLearnByCaseSection_templateObject5(), theme/* dirRTL */.gX, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var VideosContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeLearnByCaseSection__VideosContainer",
    componentId: "sc-40df0808-6"
})(_templateObject6());
var VideosHeader = styled_components_browser_esm["default"].h4.withConfig({
    displayName: "HomeLearnByCaseSection__VideosHeader",
    componentId: "sc-40df0808-7"
})(_templateObject7(), (0,theme/* fromTheme */.HW)(function(theme) {
    return theme.text.palette.accent;
}));
var StyledButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "HomeLearnByCaseSection__StyledButton",
    componentId: "sc-40df0808-8"
})(_templateObject8());
var HomeLearnByCaseSection = (0,WithSilentErrorBoundary/* withSilentErrorBoundary */.o)(/*#__PURE__*/ (0,react.memo)(function HomeLearnByCaseSection() {
    var ref;
    var ref1 = (0,lib.useTranslate)(), _ = ref1._, _n = ref1._n;
    var ref2 = (0,react.useState)({
        bodyParts: []
    }), formData = ref2[0], setFormData = ref2[1];
    var ref3 = useLearnByCaseVideosQuery(formData.bodyParts), data = ref3.data, isLoading = ref3.isLoading;
    var contentKey = (0,react.useMemo)(function() {
        return JSON.stringify(formData.bodyParts);
    }, [
        formData.bodyParts
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: formData,
        onSubmit: function(data, form) {
            setFormData(data);
            form.setSubmitting(false);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomeLearnByCaseSection_Section, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikAutoSubmit/* FormikAutoSubmit */.U, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomeLearnByCaseSection_ContentContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeSectionHeaderSecondary, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                children: _("Improve your masterskills")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeSectionHeaderPrimary, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                children: _("Watch \n by case")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                children: _("Mark the interesting part of the face and watch the existing techniques.")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeLearnByCaseSection_CTAContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
                        href: route/* route.search */.BC.search().videos(),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CTA, {
                            forwardedAs: "a",
                            children: _("See All Content")
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LearnByCaseFaceComponent, {
                    name: "bodyParts",
                    multi: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideosArea, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderTransition/* LoaderTransition */.t, {
                        Loader: internal/* Loader */.aN,
                        animateAlways: true,
                        children: !isLoading && data != null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideosContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideosHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                            children: _n("{count} video", "{count} videos", data.count, undefined, {
                                                count: "".concat(data.count)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
                                            href: {
                                                pathname: route/* route.search */.BC.search().videos(),
                                                query: ((ref = formData.bodyParts) === null || ref === void 0 ? void 0 : ref.length) > 0 ? {
                                                    bodyPart: formData.bodyParts
                                                } : {}
                                            },
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                                forwardedAs: "a",
                                                kind: "text",
                                                variant: "underline",
                                                children: _("see all")
                                            })
                                        })
                                    ]
                                }),
                                data.count === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Paragraph */.n, {
                                    children: _("Currently, there are no videos matching these filters. Please change them or try again later!")
                                }),
                                data.videos.map(function(a) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoItemPreview, {
                                        video: a
                                    }, a.slug);
                                })
                            ]
                        }, contentKey) : null
                    })
                })
            ]
        })
    });
}));

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(17573);
// EXTERNAL MODULE: ./src/utils/casePathEmptyString.ts
var casePathEmptyString = __webpack_require__(12732);
// EXTERNAL MODULE: ./src/utils/motion/transitions.ts
var transitions = __webpack_require__(84176);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useIsomorphicLayoutEffect.js
var useIsomorphicLayoutEffect = __webpack_require__(11042);
;// CONCATENATED MODULE: ./src/modules/home/components/HomeProtocolsSection/ProtocolSelect.tsx



function ProtocolSelect_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: 12px;\n  width: 570px;\n  grid-area: selector;\n\n  ",
        " {\n    width: 100%;\n    margin-left: calc(-1 * var(--left-usable-margin));\n    ",
        " {\n      margin-left: 0;\n      margin-right: calc(-1 * var(--left-usable-margin));\n    }\n  }\n"
    ]);
    ProtocolSelect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProtocolSelect_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 570px;\n  height: 570px;\n\n  ",
        " {\n    width: 310px;\n    height: 310px;\n  }\n"
    ]);
    ProtocolSelect_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProtocolSelect_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  width: 32px;\n  height: 32px;\n  margin-left: -16px;\n  margin-top: -16px;\n  transform-origin: center;\n  transform: scale(0.5);\n  border-radius: 50%;\n\n  ",
        " {\n    width: 24px;\n    height: 24px;\n    margin-left: -12px;\n    margin-top: -12px;\n  }\n\n  /* brand colour / red neauvia */\n\n  background: ",
        ";\n  /* brand colour / red neauvia */\n\n  box-shadow: 0px 0px 18.2124px\n    ",
        ";\n\n  &:after {\n    content: '';\n    width: calc(220% + 8px);\n    height: calc(220% + 8px);\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform-origin: center center;\n    transform: translate(-50%, -50%) scale(1);\n    box-sizing: content-box;\n    opacity: 0;\n    transition: opacity ",
        "s\n      ",
        ";\n    border: 1px solid ",
        ";\n    border-radius: 50%;\n  }\n"
    ]);
    ProtocolSelect_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProtocolSelect_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  will-change: transform, opacity;\n  transition: opacity ",
        "s\n    ",
        ";\n\n  & > * {\n    overflow: visible !important;\n  }\n"
    ]);
    ProtocolSelect_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ProtocolSelect_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: translate(-50%, -50%) scale(0.3);\n    opacity: 0.6;\n  }\n  to {\n    transform: translate(-50%, -50%) scale(1);\n    opacity: 0.3;\n  }\n"
    ]);
    ProtocolSelect_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ProtocolSelect_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    && {\n      ",
        " {\n        opacity: 1;\n      }\n\n      ",
        " {\n        transform: scale(0.79);\n        transition: box-shadow ",
        "s\n            ",
        ",\n          transform ",
        "s\n            ",
        ";\n        box-shadow: 0px 0px 18.2124px\n          ",
        ";\n\n        &:after {\n          opacity: 1;\n          animation: ",
        " forwards 0.8s cubic-bezier(0, 0.46, 0, 1);\n        }\n      }\n    }\n  "
    ]);
    ProtocolSelect_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ProtocolSelect_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n\n  ",
        " {\n    will-change: opacity, height;\n    opacity: 0.3;\n  }\n\n  ",
        " {\n    transition: transform ",
        "s\n      ",
        ";\n  }\n\n  &:hover,\n  &:focus {\n    ",
        " {\n      opacity: 0.8;\n    }\n\n    ",
        " {\n      transform: scale(0.7);\n      transition: box-shadow ",
        "s\n          ",
        ",\n        transform ",
        "s\n          ",
        ";\n    }\n  }\n\n  ",
        "\n\n  &.protocol_nlift {\n    ",
        ";\n\n    ",
        " {\n      ",
        "\n    }\n\n    ",
        " {\n      ",
        ";\n\n      ",
        " {\n        ",
        "\n      }\n    }\n  }\n\n  &.protocol_nboost {\n    ",
        ";\n\n    ",
        " {\n      ",
        "\n    }\n\n    ",
        " {\n      ",
        ";\n\n      ",
        " {\n        ",
        "\n      }\n    }\n  }\n\n  &.protocol_nrose {\n    ",
        ";\n\n    ",
        " {\n      ",
        "\n    }\n    ",
        " {\n      ",
        ";\n\n      ",
        " {\n        ",
        "\n      }\n\n      ",
        " {\n        ",
        "\n      }\n    }\n  }\n"
    ]);
    ProtocolSelect_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ProtocolSelect_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  background: transparent;\n  top: -100px;\n  bottom: -50px;\n  left: -70px;\n  right: -250px;\n  ",
        " {\n    left: -250px;\n    right: -70px;\n  }\n\n  ",
        " {\n    right: -100px;\n    top: -70px;\n    bottom: -30px;\n    left: -30px;\n    ",
        " {\n      right: -30px;\n      left: -100px;\n    }\n  }\n"
    ]);
    ProtocolSelect_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ProtocolSelect_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    left: ",
        "%;\n    top: ",
        "%;\n    ",
        " {\n      left: auto;\n      right: ",
        "%;\n    }\n  "
    ]);
    ProtocolSelect_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    left: ",
        "px;\n    top: ",
        "px;\n    height: ",
        "px;\n    width: ",
        "px;\n    transform-origin: center center;\n    ",
        " {\n      left: auto;\n      right: ",
        "px;\n    }\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0;\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 26px;\n\n  text-align: center;\n  letter-spacing: 0.08em;\n\n  ",
        " {\n    margin-left: 33px;\n    margin-right: 33px;\n    text-align: left;\n    color: ",
        ";\n    transition: opacity ",
        "s\n      ",
        ";\n\n    ",
        "\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  border-radius: 50%;\n  overflow: hidden;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  opacity: 0 !important;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 50%;\n  object-fit: contain;\n  object-position: center;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
















var OuterContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProtocolSelect__OuterContainer",
    componentId: "sc-fb0f81f9-0"
})(ProtocolSelect_templateObject(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, theme/* dirRTL */.gX);
var CircleContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProtocolSelect__CircleContainer",
    componentId: "sc-fb0f81f9-1"
})(ProtocolSelect_templateObject1(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var OptionDot = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProtocolSelect__OptionDot",
    componentId: "sc-fb0f81f9-2"
})(ProtocolSelect_templateObject2(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, (0,theme/* fromTheme */.HW)(function(t) {
    return t.palette.accent;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return (0,polished_esm/* transparentize */.DZ)(0.8, t.palette.accent);
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.duration * 2;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.easing.default;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.palette.accent;
}));
var OptionLabel = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "ProtocolSelect__OptionLabel",
    componentId: "sc-fb0f81f9-3"
})(ProtocolSelect_templateObject3(), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.duration * 2;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.easing.default;
}));
var animateHalo = (0,styled_components_browser_esm.keyframes)(ProtocolSelect_templateObject4());
var Option = (0,styled_components_browser_esm["default"])(Button/* CleanButton */.ux).withConfig({
    displayName: "ProtocolSelect__Option",
    componentId: "sc-fb0f81f9-4"
})(ProtocolSelect_templateObject6(), OptionLabel, OptionDot, (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.duration * 2;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.easing.default;
}), OptionLabel, OptionDot, (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.duration * 2;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.easing.decelerated;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.duration * 2;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.easing.decelerated;
}), (0,casePathEmptyString/* casePathEmptyString */.Q)("$active")((0,styled_components_browser_esm.css)(ProtocolSelect_templateObject5(), OptionLabel, OptionDot, (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.duration * 2;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.easing.decelerated;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.duration * 2;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.easing.decelerated;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return (0,polished_esm/* transparentize */.DZ)(0.2, t.palette.accent);
}), animateHalo)), getPointPositionCSS(-36), OptionLabel, function(param) {
    var $active = param.$active;
    return getLabelPositionCSS({
        idle: {
            top: -40,
            left: -8.5,
            height: 20,
            width: 67.5
        },
        active: {
            left: -7,
            top: -52,
            height: 24,
            width: 81
        }
    }, $active);
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, getPointPositionCSS(3), OptionLabel, function(param) {
    var $active = param.$active;
    return getLabelPositionCSS({
        idle: {
            top: -24,
            left: 17,
            height: 38.85,
            width: 131.13
        },
        active: {
            top: -27,
            left: 20.5,
            height: 54,
            width: 181.8
        }
    }, $active);
}, getPointPositionCSS(-66), OptionLabel, function(param) {
    var $active = param.$active;
    return getLabelPositionCSS({
        idle: {
            top: -40,
            left: -8.5,
            height: 20,
            width: 67.5
        },
        active: {
            left: -7,
            top: -52,
            height: 24,
            width: 81
        }
    }, $active);
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, getPointPositionCSS(-25), OptionLabel, function(param) {
    var $active = param.$active;
    return getLabelPositionCSS({
        idle: {
            top: -52.5,
            left: 30,
            height: 38.85,
            width: 131.13
        },
        active: {
            top: -82,
            left: 27,
            height: 54,
            width: 181.8
        }
    }, $active);
}, getPointPositionCSS(56), OptionLabel, function(param) {
    var $active = param.$active;
    return getLabelPositionCSS({
        idle: {
            top: 20,
            left: -7,
            height: 20,
            width: 75.17
        },
        active: {
            top: 28,
            left: -6,
            height: 24,
            width: 90.21
        }
    }, $active);
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, getPointPositionCSS(35), OptionLabel, function(param) {
    var $active = param.$active;
    return getLabelPositionCSS({
        idle: {
            top: 12.5,
            left: 22,
            height: 40.07,
            width: 150.56
        },
        active: {
            top: -8,
            left: 42,
            height: 54,
            width: 198
        }
    }, $active);
}, OptionLabel, function(param) {
    var $active = param.$active;
    return getLabelPositionCSS({
        idle: {
            top: 12.5,
            left: 22,
            height: 40.07,
            width: 150.56
        },
        active: {
            top: -8,
            left: 42,
            height: 54,
            width: 198
        }
    }, $active);
});
var ClickerArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProtocolSelect__ClickerArea",
    componentId: "sc-fb0f81f9-5"
})(ProtocolSelect_templateObject7(), theme/* dirRTL */.gX, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, theme/* dirRTL */.gX);
function getPointPositionCSS(angle) {
    var x = Math.cos(Math.PI * 2 / 360 * angle) * 49.8;
    var y = Math.sin(Math.PI * 2 / 360 * angle) * 49.8;
    return (0,styled_components_browser_esm.css)(ProtocolSelect_templateObject8(), 50 + x, 50 + y, theme/* dirRTL */.gX, 50 + x);
}
function getLabelPositionCSS(position, active) {
    var state = active ? position.active : position.idle;
    return (0,styled_components_browser_esm.css)(_templateObject9(), state.left, state.top, state.height, state.width, theme/* dirRTL */.gX, state.left);
}
var noProtocolSelectedImage = (__webpack_require__(43171)/* ["default"].src */ .Z.src);
var SubText = styled_components_browser_esm["default"].p.withConfig({
    displayName: "ProtocolSelect__SubText",
    componentId: "sc-fb0f81f9-6"
})(_templateObject11(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, (0,theme/* fromTheme */.HW)(function(t) {
    return t.text.palette.secondary;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.duration;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.easing.default;
}), (0,casePathEmptyString/* casePathEmptyString */.Q)("$active")((0,styled_components_browser_esm.css)(_templateObject10())));
var InnerContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProtocolSelect__InnerContainer",
    componentId: "sc-fb0f81f9-7"
})(_templateObject12(), common/* layer */.EY);
var HiddenImage = (0,styled_components_browser_esm["default"])((image_default())).withConfig({
    displayName: "ProtocolSelect__HiddenImage",
    componentId: "sc-fb0f81f9-8"
})(_templateObject13(), common/* layer */.EY);
var StyledSvg = styled_components_browser_esm["default"].svg.withConfig({
    displayName: "ProtocolSelect__StyledSvg",
    componentId: "sc-fb0f81f9-9"
})(_templateObject14(), common/* layer */.EY);
var StyledImage = (0,styled_components_browser_esm["default"])((image_default())).withConfig({
    displayName: "ProtocolSelect__StyledImage",
    componentId: "sc-fb0f81f9-10"
})(_templateObject15());
var ProtocolSelect = /*#__PURE__*/ (0,react.memo)(function(param) {
    var protocols = param.protocols, activeProtocol = param.activeProtocol, onSelect = param.onSelect;
    var _ = (0,lib.useTranslate)()._;
    var image = (activeProtocol === null || activeProtocol === void 0 ? void 0 : activeProtocol.selectorImage) || noProtocolSelectedImage;
    var ref = (0,react.useState)(false), imageReady = ref[0], setImageReady = ref[1];
    (0,useIsomorphicLayoutEffect/* default */.Z)(function() {
        setImageReady(false);
    }, [
        image
    ]);
    var onLoad = (0,react.useCallback)(function() {
        setImageReady(true);
    }, [
        setImageReady
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OuterContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CircleContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                            exitBeforeEnter: true,
                            children: image && imageReady ? /*#__PURE__*/ (0,react.createElement)(motion/* motion.div */.E.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
                                fade: true
                            })), {
                                key: image
                            }), /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                                src: image,
                                sizes: "(min-width: 1000px) 50vw, 90vw",
                                quality: "75",
                                layout: "fill"
                            })) : null
                        })
                    }),
                    image && /*#__PURE__*/ (0,jsx_runtime.jsx)(HiddenImage, {
                        onLoadingComplete: onLoad,
                        src: image,
                        sizes: "(min-width: 1000px) 50vw, 90vw",
                        quality: "75",
                        layout: "fill"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSvg, {
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 570 570",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M284.72 0A284.72 284.72 0 0 0 0 284.72a284.72 284.72 0 0 0 284.72 284.72 284.72 284.72 0 0 0 284.72-284.72A284.72 284.72 0 0 0 284.72 0zm2.78 5.29a280 280 0 0 1 280 280 280 280 0 0 1-280 280 280 280 0 0 1-280-280 280 280 0 0 1 280-280z",
                            fill: "#cd0338"
                        })
                    }),
                    protocols.map(function(protocol) {
                        var isActive = activeProtocol === protocol;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Option, {
                            $active: isActive,
                            className: "protocol_".concat(protocol.slug),
                            onClick: function(e) {
                                e.preventDefault();
                                onSelect(protocol);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickerArea, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionDot, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionLabel, {
                                    layout: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectusImage/* DirectusImage */.q, {
                                        src: protocol.selectorLogo,
                                        layout: "fill",
                                        sizes: "10vw",
                                        quality: "100"
                                    })
                                })
                            ]
                        }, protocol.id);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubText, {
                $active: !!activeProtocol,
                children: _("CHOOSE ONE OF THE POINTS")
            })
        ]
    });
});
ProtocolSelect.displayName = "ProtocolSelect";

// EXTERNAL MODULE: ./src/utils/reactQuery.tsx
var reactQuery = __webpack_require__(4766);
// EXTERNAL MODULE: ./src/utils/queryCommonOptions.tsx
var queryCommonOptions = __webpack_require__(57750);
// EXTERNAL MODULE: ./src/modules/protocols/hooks/useProtocolsQuery.ts + 1 modules
var useProtocolsQuery = __webpack_require__(79169);
;// CONCATENATED MODULE: ./src/modules/home/components/HomeProtocolsSection/index.tsx





function HomeProtocolsSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  ",
        " {\n    // damned incoherent designs!\n    margin-bottom: -90px;\n  }\n"
    ]);
    HomeProtocolsSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HomeProtocolsSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: description;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 24px;\n  /* or 150% */\n\n  /* Gray 3 */\n\n  color: ",
        ";\n\n  display: grid;\n  grid-template-areas: 'text' 'content' 'cta';\n  gap: 20px;\n  margin-top: -15px;\n\n  ",
        " {\n    width: 275px;\n  }\n"
    ]);
    HomeProtocolsSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HomeProtocolsSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  margin-top: 184px;\n  grid-template-areas: 'header selector' 'description selector' '. selector';\n  grid-template-rows: auto auto 1fr;\n  grid-template-columns: 300px 1fr;\n  gap: 0 34px;\n\n  ",
        " {\n    margin-top: 71px;\n\n    grid-template-areas: 'header' 'selector' 'description';\n    grid-template-rows: auto auto auto;\n    grid-template-columns: 1fr;\n    gap: 24px 0;\n  }\n"
    ]);
    HomeProtocolsSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HomeProtocolsSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 184px;\n\n  ",
        " {\n    margin-top: 5px;\n  }\n"
    ]);
    HomeProtocolsSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HomeProtocolsSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: content;\n  display: flex;\n  flex-flow: row;\n  gap: 20px;\n  min-height: 48.72px;\n"
    ]);
    HomeProtocolsSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HomeProtocolsSection_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: cta;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  grid-gap: 8px;\n  padding-bottom: 24px;\n"
    ]);
    HomeProtocolsSection_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function HomeProtocolsSection_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: auto auto;\n  align-items: baseline;\n  gap: 10px;\n  color: ",
        ";\n"
    ]);
    HomeProtocolsSection_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function HomeProtocolsSection_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  font-size: 41px;\n  line-height: 61px;\n"
    ]);
    HomeProtocolsSection_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function HomeProtocolsSection_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  line-height: 21px;\n"
    ]);
    HomeProtocolsSection_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function HomeProtocolsSection_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    transform: rotate(180deg);\n  }\n  path {\n    stroke: currentColor !important;\n  }\n"
    ]);
    HomeProtocolsSection_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function HomeProtocolsSection_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 0px 8px;\n"
    ]);
    HomeProtocolsSection_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function HomeProtocolsSection_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    HomeProtocolsSection_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
























var HomeProtocolsSection_Section = (0,styled_components_browser_esm["default"])(HomeSection).withConfig({
    displayName: "HomeProtocolsSection__Section",
    componentId: "sc-e65772aa-0"
})(HomeProtocolsSection_templateObject(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var protocolExtraData = {
    nboost: {
        selectorImage: (__webpack_require__(59772)/* ["default"].src */ .Z.src),
        selectorLogo: __webpack_require__(97277)
    },
    nlift: {
        selectorImage: (__webpack_require__(59772)/* ["default"].src */ .Z.src),
        selectorLogo: __webpack_require__(69909)
    },
    nrose: {
        selectorImage: (__webpack_require__(70166)/* ["default"].src */ .Z.src),
        selectorLogo: __webpack_require__(25759)
    }
};
var HomeSectionDescription = (0,styled_components_browser_esm["default"])(motion/* motion.p */.E.p).withConfig({
    displayName: "HomeProtocolsSection__HomeSectionDescription",
    componentId: "sc-e65772aa-1"
})(HomeProtocolsSection_templateObject1(), (0,theme/* fromTheme */.HW)(function(t) {
    return t.text.palette.primary;
}), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var StyledHomeSectionPaddedContent = (0,styled_components_browser_esm["default"])(HomeSectionPaddedContent).withConfig({
    displayName: "HomeProtocolsSection__StyledHomeSectionPaddedContent",
    componentId: "sc-e65772aa-2"
})(HomeProtocolsSection_templateObject2(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var StyledHomeSectionHeaderPrimary = (0,styled_components_browser_esm["default"])(HomeSectionHeaderPrimary).withConfig({
    displayName: "HomeProtocolsSection__StyledHomeSectionHeaderPrimary",
    componentId: "sc-e65772aa-3"
})(HomeProtocolsSection_templateObject3(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var HomeProtocolsSectionContentCountBlock = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeProtocolsSection__HomeProtocolsSectionContentCountBlock",
    componentId: "sc-e65772aa-4"
})(HomeProtocolsSection_templateObject4());
var HomeProtocolsSectionCTABlock = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeProtocolsSection__HomeProtocolsSectionCTABlock",
    componentId: "sc-e65772aa-5"
})(HomeProtocolsSection_templateObject5());
var HomeProtocolsSectionContentCount = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeProtocolsSection__HomeProtocolsSectionContentCount",
    componentId: "sc-e65772aa-6"
})(HomeProtocolsSection_templateObject6(), (0,theme/* fromTheme */.HW)(function(t) {
    return t.text.palette.accent;
}));
var HomeProtocolsSectionContentCountNumber = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeProtocolsSection__HomeProtocolsSectionContentCountNumber",
    componentId: "sc-e65772aa-7"
})(HomeProtocolsSection_templateObject7());
var HomeProtocolsSectionContentCountLabel = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeProtocolsSection__HomeProtocolsSectionContentCountLabel",
    componentId: "sc-e65772aa-8"
})(HomeProtocolsSection_templateObject8());
var StyledArrowRight = (0,styled_components_browser_esm["default"])(icons_ArrowRight).withConfig({
    displayName: "HomeProtocolsSection__StyledArrowRight",
    componentId: "sc-e65772aa-9"
})(HomeProtocolsSection_templateObject9(), theme/* dirRTL */.gX);
var protocolsContentCountQuery = function(apis, protocolSlug) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queryCommonOptions/* longStaleQueryBase */.R), {
        queryKey: [
            query/* QueryKeyGroup.Public */.P.Public,
            "protcols-content-count",
            protocolSlug
        ],
        queryFn: function queryFn() {
            return (0,_async_to_generator/* default */.Z)(function() {
                var sdk, filter, videosCount;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            sdk = apis.directus().sdk;
                            filter = {
                                showcase: {
                                    _eq: true
                                },
                                subjects: {
                                    subjects_id: {
                                        slug: {
                                            _eq: "protocol-treatment"
                                        }
                                    }
                                },
                                tags: {
                                    tags_id: {
                                        slug: {
                                            _eq: protocolSlug
                                        }
                                    }
                                }
                            };
                            return [
                                4,
                                sdk.items("videos").readByQuery({
                                    fields: [],
                                    limit: 0,
                                    meta: "filter_count",
                                    filter: filter
                                }).then(function(r) {
                                    var ref;
                                    return (ref = r.meta) === null || ref === void 0 ? void 0 : ref.filter_count;
                                })
                            ];
                        case 1:
                            videosCount = _state.sent();
                            return [
                                2,
                                {
                                    videos: videosCount || 0
                                }
                            ];
                    }
                });
            })();
        }
    });
};
var useProtocolsContentCountQuery = function(protocolSlug) {
    var apis = (0,useAPIs/* useAPIs */.V)();
    return (0,es.useQuery)(protocolsContentCountQuery(apis, protocolSlug));
};
function ProtocolContentCounters(props) {
    var ref = useProtocolsContentCountQuery(props.protocol.slug), counters = ref.data;
    var _n = (0,lib.useTranslate)()._n;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderTransition/* LoaderTransition */.t, {
        children: counters ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomeProtocolsSectionContentCount, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeProtocolsSectionContentCountNumber, {
                        children: counters.videos
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeProtocolsSectionContentCountLabel, {
                        children: _n("video", "videos", counters.videos)
                    })
                ]
            })
        }) : null
    });
}
var HomeProtocolsSectionTagsBlock = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeProtocolsSection__HomeProtocolsSectionTagsBlock",
    componentId: "sc-e65772aa-10"
})(HomeProtocolsSection_templateObject10());
var HomeProtocolsSectionTagsTag = styled_components_browser_esm["default"].span.withConfig({
    displayName: "HomeProtocolsSection__HomeProtocolsSectionTagsTag",
    componentId: "sc-e65772aa-11"
})(HomeProtocolsSection_templateObject11());
var HomeProtocolsSection = (0,WithSilentErrorBoundary/* withSilentErrorBoundary */.o)((0,reactQuery/* withQueries */.kS)({
    protocols: useProtocolsQuery/* useProtocolsQuery */.t
}, function(param) {
    var protocols = param.protocols;
    var extendedProtocols = (0,react.useMemo)(function() {
        return protocols.filter(function(protocol) {
            return Object.keys(protocolExtraData).includes(protocol.slug);
        }).map(function(protocol) {
            return (0,_object_spread/* default */.Z)({}, protocol, protocolExtraData[protocol.slug]);
        });
    }, [
        protocols
    ]);
    var _ = (0,lib.useTranslate)()._;
    var ref = (0,react.useRef)(null);
    var ref1;
    var ref2 = (0,react.useState)((ref1 = extendedProtocols[0]) !== null && ref1 !== void 0 ? ref1 : null), activeProtocol = ref2[0], setActiveProtocol = ref2[1];
    // useClickAway(ref, () => {
    //   setActiveProtocol(null);
    // });
    var translateItem = (0,useTranslateItem/* useTranslateItem */.L)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeProtocolsSection_Section, {
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHomeSectionPaddedContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHomeSectionHeaderPrimary, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        children: _("Neauvia \n protocols")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                    exitBeforeEnter: true,
                    children: activeProtocol ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomeSectionDescription, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        as: "div"
                    }, (0,transitions/* makeTransition */.Vr)({
                        fade: true,
                        from: "topMore",
                        to: "bottomMore"
                    })), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeProtocolsSectionTagsBlock, {
                                children: activeProtocol.tags.map(function(t) {
                                    return t.tags_id;
                                }).map(translateItem).map(function(tag) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeProtocolsSectionTagsTag, {
                                        children: tag.name
                                    }, tag.id);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeProtocolsSectionContentCountBlock, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtocolContentCounters, {
                                    protocol: activeProtocol
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomeProtocolsSectionCTABlock, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
                                        passHref: true,
                                        href: route/* route.search */.BC.search({
                                            tag: activeProtocol.slug,
                                            subject: "protocol-treatment"
                                        }).videos(),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                                            as: "a",
                                            kind: "text",
                                            variant: "secondary",
                                            icon: StyledArrowRight,
                                            iconProps: {
                                                position: "right"
                                            },
                                            children: _("See all")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
                                        passHref: true,
                                        href: route/* route.protocol */.BC.protocol(activeProtocol).page(),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                                            as: "a",
                                            kind: "text",
                                            variant: "secondary",
                                            icon: StyledArrowRight,
                                            iconProps: {
                                                position: "right"
                                            },
                                            children: _("Discover the protocol")
                                        })
                                    })
                                ]
                            })
                        ]
                    }), activeProtocol.id) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeSectionDescription, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
                        fade: true,
                        from: "topMore",
                        to: "bottomMore"
                    })), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: _("Neauvia has developed comprehensive protocols, supported by clinical data, that combine rejuvenation therapies and grant clinically proven superior results.")
                        })
                    }), "default")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtocolSelect, {
                    protocols: extendedProtocols,
                    activeProtocol: activeProtocol,
                    onSelect: setActiveProtocol
                })
            ]
        })
    });
}));

// EXTERNAL MODULE: ./vendor/mods/media-breakpoints-fresnel/components/Media.tsx
var Media = __webpack_require__(50696);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/components/common/FormatDate.tsx
var FormatDate = __webpack_require__(23955);
// EXTERNAL MODULE: ./src/modules/events/hooks/useFlattenEvent.ts
var useFlattenEvent = __webpack_require__(73082);
;// CONCATENATED MODULE: ./src/modules/home/components/HomeTVSection/HomeTVSectionUpcoming.tsx

function HomeTVSectionUpcoming_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 0;\n  min-width: 0;\n"
    ]);
    HomeTVSectionUpcoming_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HomeTVSectionUpcoming_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: normal;\n  font-size: 13px;\n  line-height: 18px;\n  letter-spacing: 0.64rpx;\n  text-transform: uppercase;\n  margin-bottom: 12px;\n"
    ]);
    HomeTVSectionUpcoming_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HomeTVSectionUpcoming_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n"
    ]);
    HomeTVSectionUpcoming_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HomeTVSectionUpcoming_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 16px;\n  margin-top: 4px;\n"
    ]);
    HomeTVSectionUpcoming_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










var HomeTVSectionUpcoming_Container = (0,styled_components_browser_esm["default"])(motion/* motion.a */.E.a).withConfig({
    displayName: "HomeTVSectionUpcoming__Container",
    componentId: "sc-5110810f-0"
})(HomeTVSectionUpcoming_templateObject());
var HomeTVSectionUpcoming_Header = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "HomeTVSectionUpcoming__Header",
    componentId: "sc-5110810f-1"
})(HomeTVSectionUpcoming_templateObject1());
var HomeTVSectionUpcoming_Date = styled_components_browser_esm["default"].h4.withConfig({
    displayName: "HomeTVSectionUpcoming__Date",
    componentId: "sc-5110810f-2"
})(HomeTVSectionUpcoming_templateObject2());
var Description = styled_components_browser_esm["default"].p.withConfig({
    displayName: "HomeTVSectionUpcoming__Description",
    componentId: "sc-5110810f-3"
})(HomeTVSectionUpcoming_templateObject3());
var HomeTVSectionUpcoming = (0,WithSilentErrorBoundary/* withSilentErrorBoundary */.o)(function(param) {
    var event = param.event;
    var ref;
    var _ = (0,lib.useTranslate)()._;
    var flatEvent = (0,useFlattenEvent/* useFlattenEvent */.p)(event);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
        href: route/* route.events */.BC.events().upcoming(),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomeTVSectionUpcoming_Container, {
            layout: "position",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTVSectionUpcoming_Header, {
                    children: _("Upcoming event")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTVSectionUpcoming_Date, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatDate */.r2, {
                        format: "do MMMM yyyy",
                        children: flatEvent.startDate
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                    children: ((ref = flatEvent.type) === null || ref === void 0 ? void 0 : ref.name) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            flatEvent.type.name,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            flatEvent.name
                        ]
                    }) : flatEvent.name
                })
            ]
        })
    });
});

// EXTERNAL MODULE: ./src/services/tvSchedule.ts + 4 modules
var tvSchedule = __webpack_require__(73846);
// EXTERNAL MODULE: ./node_modules/rambda/dist/rambda.esm.js
var rambda_esm = __webpack_require__(49713);
// EXTERNAL MODULE: ./src/modules/events/hooks/useUpcomingEventsListQuery.ts
var useUpcomingEventsListQuery = __webpack_require__(93928);
// EXTERNAL MODULE: ./src/components/ScrollableContent.tsx
var ScrollableContent = __webpack_require__(53402);
// EXTERNAL MODULE: ./src/modules/videos/utils/isLiveStream.ts
var isLiveStream = __webpack_require__(81467);
;// CONCATENATED MODULE: ./src/modules/home/components/HomeTVSection/HomeTVSectionSchedule.tsx




function HomeTVSectionSchedule_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: normal;\n  font-size: 13px;\n  line-height: 18px;\n  letter-spacing: 0.64rpx;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n"
    ]);
    HomeTVSectionSchedule_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HomeTVSectionSchedule_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(100% + 100px);\n  height: 100%;\n  margin-left: -46px;\n  ",
        " {\n    margin-left: 0;\n    margin-right: -46px;\n    & > .simplebar-track.simplebar-vertical {\n      left: -6px;\n      right: auto;\n    }\n  }\n\n  @media (max-width: 1720px) {\n    width: calc(100% + 40px);\n  }\n"
    ]);
    HomeTVSectionSchedule_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HomeTVSectionSchedule_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: start;\n  min-height: 0;\n  margin: 0;\n  padding: 0;\n  flex: 1;\n"
    ]);
    HomeTVSectionSchedule_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HomeTVSectionSchedule_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 60px;\n  padding-right: 6px;\n  ",
        " {\n    padding-left: 6px;\n    padding-right: 60px;\n  }\n"
    ]);
    HomeTVSectionSchedule_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HomeTVSectionSchedule_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: title;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 15px;\n  ",
        ";\n"
    ]);
    HomeTVSectionSchedule_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HomeTVSectionSchedule_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:not(:last-child) {\n    margin-bottom: 14px;\n  }\n"
    ]);
    HomeTVSectionSchedule_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function HomeTVSectionSchedule_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 1;\n      transform: ",
        ";\n\n      ",
        " {\n        font-weight: 500;\n      }\n\n      &:hover {\n        opacity: 1;\n      }\n    "
    ]);
    HomeTVSectionSchedule_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function HomeTVSectionSchedule_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  width: 100%;\n  grid-template-areas: 'time thumbnail title' 'lock thumbnail title';\n  grid-template-columns: 36px 64px 1fr;\n  grid-column-gap: 10px;\n  opacity: 0.5;\n  transition: all ",
        "s\n    ",
        ";\n\n  ",
        ";\n"
    ]);
    HomeTVSectionSchedule_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function HomeTVSectionSchedule_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 18px;\n  letter-spacing: 0.64rpx;\n  text-transform: uppercase;\n  justify-self: flex-end;\n  text-align: right;\n"
    ]);
    HomeTVSectionSchedule_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function HomeTVSectionSchedule_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: thumbnail;\n  width: 100%;\n  height: 40px;\n  position: relative;\n\n  img {\n    object-fit: cover;\n    object-position: center;\n  }\n"
    ]);
    HomeTVSectionSchedule_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function HomeTVSectionSchedule_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: row-reverse;\n    align-items: center;\n    margin-top: -4px;\n    time {\n      padding-top: 4px;\n    }\n  "
    ]);
    HomeTVSectionSchedule_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function HomeTVSectionSchedule_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: time;\n  ",
        ";\n"
    ]);
    HomeTVSectionSchedule_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function HomeTVSectionSchedule_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 3px;\n"
    ]);
    HomeTVSectionSchedule_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function HomeTVSectionSchedule_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  text-transform: uppercase;\n  font-weight: 600;\n  font-size: 9px;\n  margin-top: -3px;\n  &:before {\n    content: '';\n    display: block;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: currentColor;\n    margin: 0 4px 0 0;\n    ",
        " {\n      margin: 0 0 0 4px;\n    }\n  }\n"
    ]);
    HomeTVSectionSchedule_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}























var HomeTVSectionSchedule_Header = (0,styled_components_browser_esm["default"])(motion/* motion.h3 */.E.h3).withConfig({
    displayName: "HomeTVSectionSchedule__Header",
    componentId: "sc-3c6eb977-0"
})(HomeTVSectionSchedule_templateObject());
var StyledScrollableContent = (0,styled_components_browser_esm["default"])(ScrollableContent/* ScrollableContent */.t).withConfig({
    displayName: "HomeTVSectionSchedule__StyledScrollableContent",
    componentId: "sc-3c6eb977-1"
})(HomeTVSectionSchedule_templateObject1(), theme/* dirRTL */.gX);
var Schedule = (0,styled_components_browser_esm["default"])(motion/* motion.ol */.E.ol).withConfig({
    displayName: "HomeTVSectionSchedule__Schedule",
    componentId: "sc-3c6eb977-2"
})(HomeTVSectionSchedule_templateObject2());
var ScheduleItems = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "HomeTVSectionSchedule__ScheduleItems",
    componentId: "sc-3c6eb977-3"
})(HomeTVSectionSchedule_templateObject3(), theme/* dirRTL */.gX);
var ScheduleItemTitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeTVSectionSchedule__ScheduleItemTitle",
    componentId: "sc-3c6eb977-4"
})(HomeTVSectionSchedule_templateObject4(), (0,common/* lineClamp */.Sf)(3));
var ScheduleItemWrapper = (0,motion/* motion */.E)(styled_components_browser_esm["default"].li.withConfig({
    displayName: "HomeTVSectionSchedule__ScheduleItemWrapper",
    componentId: "sc-3c6eb977-5"
})(HomeTVSectionSchedule_templateObject5()));
var ScheduleItem = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeTVSectionSchedule__ScheduleItem",
    componentId: "sc-3c6eb977-6"
})(HomeTVSectionSchedule_templateObject7(), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.duration;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.easing.decelerated;
}), function(param) {
    var $active = param.$active, $rtl = param.$rtl;
    return $active && (0,styled_components_browser_esm.css)(HomeTVSectionSchedule_templateObject6(), $rtl ? "translateX(calc((-36px - 10px) * -1))" : "translateX(calc(-36px - 10px))", ScheduleItemTitle);
});
var ScheduleItemTime = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeTVSectionSchedule__ScheduleItemTime",
    componentId: "sc-3c6eb977-7"
})(HomeTVSectionSchedule_templateObject8());
var ScheduleItemThumbnail = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeTVSectionSchedule__ScheduleItemThumbnail",
    componentId: "sc-3c6eb977-8"
})(HomeTVSectionSchedule_templateObject9());
var StartDate = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeTVSectionSchedule__StartDate",
    componentId: "sc-3c6eb977-9"
})(HomeTVSectionSchedule_templateObject11(), (0,casePathEmptyString/* casePathEmptyString */.Q)("$row")((0,styled_components_browser_esm.css)(HomeTVSectionSchedule_templateObject10())));
var ScheduleItemLock = styled_components_browser_esm["default"].span.withConfig({
    displayName: "HomeTVSectionSchedule__ScheduleItemLock",
    componentId: "sc-3c6eb977-10"
})(HomeTVSectionSchedule_templateObject12());
var LiveIndicator = styled_components_browser_esm["default"].span.withConfig({
    displayName: "HomeTVSectionSchedule__LiveIndicator",
    componentId: "sc-3c6eb977-11"
})(HomeTVSectionSchedule_templateObject13(), theme/* dirRTL */.gX);
var ScheduleItemSubtitle = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        style: {
            fontWeight: 600
        },
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        ]
    });
};
var homeTVSectionScheduleQueryHooks = {
    schedule: tvSchedule/* useTVScheduleQuery */.Vn,
    events: useUpcomingEventsListQuery/* useUpcomingEventsListQuery */.k
};
var HomeTVSectionSchedule = (0,WithSilentErrorBoundary/* withSilentErrorBoundary */.o)((0,reactQuery/* withQueries */.kS)(homeTVSectionScheduleQueryHooks, function(param) {
    var schedule = param.schedule, events = param.events, onScheduleClick = param.onScheduleClick;
    var _ = (0,lib.useTranslate)()._;
    var translateItem = (0,useTranslateItem/* useTranslateItem */.L)();
    var isRTL = (0,useIsRTL/* useIsRTL */.S)();
    var scheduledVideos = (0,react.useMemo)(function() {
        return schedule.map((0,rambda_esm.evolve)({
            video: translateItem
        }));
    }, [
        translateItem,
        schedule
    ]);
    var upcomingLiveEvent = (0,rambda_esm.head)(events);
    var ref = (0,_sliced_to_array/* default */.Z)((0,tvSchedule/* useCurrentAndUpcomingPrograms */.Q0)(scheduledVideos), 2), currentVideo = ref[0], availableProgrammes = ref[1];
    var nextProgramme = (0,react.useMemo)(function() {
        var activeVideoIndex = availableProgrammes.findIndex(function(a) {
            return a === currentVideo;
        });
        return availableProgrammes[activeVideoIndex + 1];
    }, [
        availableProgrammes,
        currentVideo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTVSectionSchedule_Header, {
                layout: "position",
                children: _("TODAY PROGRAM")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Schedule, {
                layout: "position",
                onClick: onScheduleClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledScrollableContent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduleItems, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                            initial: false,
                            children: availableProgrammes.map(function(a) {
                                var isLive = (0,isLiveStream/* isLiveStream */.t)(a.video);
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduleItemWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    layout: "position"
                                }, (0,transitions/* makeTransition */.Vr)({
                                    fade: true,
                                    to: "topFull",
                                    sortZIndex: true
                                })), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScheduleItem, {
                                        $rtl: isRTL,
                                        $active: a === currentVideo,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScheduleItemTime, {
                                                children: [
                                                    a === currentVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduleItemSubtitle, {
                                                        children: _("now")
                                                    }),
                                                    a === nextProgramme && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduleItemSubtitle, {
                                                        children: _("Next")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StartDate, {
                                                        $row: a === nextProgramme || a === currentVideo,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatHour */.t, {
                                                                children: a.startDate
                                                            }),
                                                            !(0,permissions/* canUserAccessItem */.k)(a.video) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduleItemLock, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lock/* Lock */.H, {
                                                                    size: 12
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduleItemThumbnail, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectusImage/* DirectusImage */.q, {
                                                    src: a.video.thumbnail.id,
                                                    layout: "fill",
                                                    sizes: "(min-width: 1000px) 5vw, 10vw"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScheduleItemTitle, {
                                                children: [
                                                    isLive && /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveIndicator, {
                                                        children: _("Live")
                                                    }),
                                                    a.video.name
                                                ]
                                            })
                                        ]
                                    })
                                }), a.id);
                            })
                        })
                    })
                })
            }),
            upcomingLiveEvent && /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTVSectionUpcoming, {
                event: upcomingLiveEvent
            })
        ]
    });
}));

// EXTERNAL MODULE: ./src/services/tvScheduleConfiguration.ts
var tvScheduleConfiguration = __webpack_require__(15935);
// EXTERNAL MODULE: ./src/modules/home/components/HomeTVSection/common.tsx
var HomeTVSection_common = __webpack_require__(77917);
// EXTERNAL MODULE: ./src/components/player/playerId.ts
var playerId = __webpack_require__(19295);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var react_redux_es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/store/miniplayer/selectors.ts
var selectors = __webpack_require__(95406);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-hook-inview/dist/esm/index.js + 2 modules
var esm = __webpack_require__(69671);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useUpdateEffect.js
var useUpdateEffect = __webpack_require__(48286);
// EXTERNAL MODULE: ./src/components/common/Layout/Miniplayer/index.tsx + 6 modules
var Miniplayer = __webpack_require__(19169);
// EXTERNAL MODULE: ./src/components/common/Layout/Miniplayer/useMiniplayerAutoOpen.tsx
var useMiniplayerAutoOpen = __webpack_require__(93771);
// EXTERNAL MODULE: ./src/hooks/useDelayedValue.ts
var useDelayedValue = __webpack_require__(12230);
// EXTERNAL MODULE: ./src/utils/iOS.ts
var iOS = __webpack_require__(9570);
;// CONCATENATED MODULE: ./src/modules/home/hooks/useTVLikeMiniplayerObserver.ts









var useTVLikeMiniplayerObserver = function(player, isMiniplayerPlayingSomethingElseThanTV) {
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useInView */.Y)({
        threshold: 0.5
    }), 2), ref1 = ref[0], isVisible = ref[1];
    var inView = (0,useDelayedValue/* useDelayedValue */.t)(isVisible, 300);
    var moveIntoTVPlayerContainer = (0,react.useCallback)(function() {
        if (!isMiniplayerPlayingSomethingElseThanTV) {
            var ref;
            (ref = Miniplayer.miniplayerController["return"]) === null || ref === void 0 ? void 0 : ref.call(Miniplayer.miniplayerController);
        }
    }, [
        isMiniplayerPlayingSomethingElseThanTV
    ]);
    var moveIntoMiniplayer = (0,react.useCallback)(function() {
        if (!isMiniplayerPlayingSomethingElseThanTV && !(0,useMiniplayerAutoOpen/* hasMiniplayerBeenClosed */.I)()) {
            var ref;
            (ref = player.current) === null || ref === void 0 ? void 0 : ref.openInMiniplayer({
                muted: (0,iOS/* iOS */.g)() ? true : undefined
            });
        }
    }, [
        isMiniplayerPlayingSomethingElseThanTV,
        player
    ]);
    (0,useUpdateEffect/* default */.Z)(function() {
        if (!inView) {
            moveIntoMiniplayer();
        } else {
            moveIntoTVPlayerContainer();
        }
    }, [
        inView
    ]);
    var handleRouteChangeStart = (0,react.useCallback)(function(targetRoute) {
        var ref;
        var isOnTheSamePage = (targetRoute === null || targetRoute === void 0 ? void 0 : (ref = targetRoute.split) === null || ref === void 0 ? void 0 : ref.call(targetRoute, "?")[0]) === router.route;
        if (!isOnTheSamePage) {
            moveIntoMiniplayer();
        }
    }, [
        router.route,
        moveIntoMiniplayer
    ]);
    (0,react.useEffect)(function() {
        router.events.on("routeChangeStart", handleRouteChangeStart);
        return function() {
            return router.events.off("routeChangeStart", handleRouteChangeStart);
        };
    }, [
        handleRouteChangeStart,
        router.events
    ]);
    return ref1;
};

// EXTERNAL MODULE: ./src/utils/storage.ts
var storage = __webpack_require__(25849);
;// CONCATENATED MODULE: ./src/modules/home/components/HomeTVSection/NeauviaTVPlayer.tsx

function NeauviaTVPlayer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 40% !important;\n  left: 0;\n  right: 0;\n  bottom: 40%;\n  pointer-events: none;\n  user-select: none;\n  visibility: hidden;\n"
    ]);
    NeauviaTVPlayer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var VisibilityObserver = styled_components_browser_esm["default"].span.withConfig({
    displayName: "NeauviaTVPlayer__VisibilityObserver",
    componentId: "sc-d9dbfd72-0"
})(NeauviaTVPlayer_templateObject());
var wistiaOptions = {
    playbar: false,
    playSuspendedOffScreen: false,
    smallPlayButton: false,
    playButton: false
};
var NeauviaTVPlayer = /*#__PURE__*/ (0,react.memo)(function NeauviaTVPlayer(param) {
    var video = param.video, isFocused = param.isFocused;
    var player = (0,react.useRef)(null);
    var liveOnPlayCallback = (0,HomeTVSection_common/* useLiveOnPlayCallback */._)(video, player);
    var onOpenMiniplayer = (0,react.useCallback)(function() {
        storage/* sessionStorage.removeItem */.y.removeItem("nc_tv-miniplayer-closed");
    }, []);
    var currentMiniplayer = (0,react_redux_es/* useSelector */.v9)(selectors/* selectMiniplayerCurrent */.kD);
    var isMiniplayerPlayingSomethingElseThanTV = (0,react.useMemo)(function() {
        return !!(currentMiniplayer && !currentMiniplayer.playerId.includes(playerId/* PlayerId.TVLike */.z.TVLike));
    }, [
        currentMiniplayer
    ]);
    var isInitiallyMuted = (0,react.useMemo)(function() {
        return isMiniplayerPlayingSomethingElseThanTV || undefined;
    }, [
        isMiniplayerPlayingSomethingElseThanTV
    ]);
    var playerControls = (0,react.useMemo)(function() {
        return {
            userActions: {
                enabled: true,
                miniplayer: true
            },
            relatedVideos: {
                enabled: false
            },
            summary: {
                enabled: isFocused !== null && isFocused !== void 0 ? isFocused : false
            }
        };
    }, [
        isFocused
    ]);
    var ref = useTVLikeMiniplayerObserver(player, isMiniplayerPlayingSomethingElseThanTV);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityObserver, {
                ref: ref
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_player/* NeauviaPlayer */.l9, {
                ref: player,
                ar: 16 / 9,
                playerId: playerId/* PlayerId.TVLike */.z.TVLike,
                video: video.video,
                playFrom: video.playFrom,
                initialMuted: isInitiallyMuted,
                loop: true,
                autoPlay: true,
                wistiaOptions: wistiaOptions,
                onPlay: liveOnPlayCallback,
                onOpenMiniplayer: onOpenMiniplayer,
                controls: playerControls
            })
        ]
    });
});

// EXTERNAL MODULE: ./src/components/icons/Close.tsx
var Close = __webpack_require__(34039);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./src/components/icons/Live.tsx
var Live = __webpack_require__(2898);
;// CONCATENATED MODULE: ./src/modules/home/components/HomeTVSection/HomeTVLiveIndicator.tsx




function HomeTVLiveIndicator_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n  background: ",
        ";\n  max-width: max-content;\n  padding: 5px 9px 5px 4px;\n  border-radius: 30px;\n  ",
        " {\n    padding: 2px 6px 2px 3px;\n  }\n"
    ]);
    HomeTVLiveIndicator_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HomeTVLiveIndicator_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  font-size: 14px;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  margin-left: 8px;\n  ",
        " {\n    margin-left: 4px;\n    font-size: 10px;\n  }\n"
    ]);
    HomeTVLiveIndicator_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HomeTVLiveIndicator_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    width: 11px;\n    height: 11px;\n  }\n"
    ]);
    HomeTVLiveIndicator_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var HomeTVLiveIndicator_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeTVLiveIndicator__Container",
    componentId: "sc-2cf6ff9b-0"
})(HomeTVLiveIndicator_templateObject(), (0,theme/* fromTheme */.HW)(function(t) {
    return t.palette.accent;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.text.palette.primary;
}), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var Label = styled_components_browser_esm["default"].span.withConfig({
    displayName: "HomeTVLiveIndicator__Label",
    componentId: "sc-2cf6ff9b-1"
})(HomeTVLiveIndicator_templateObject1(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var LiveIcon = (0,styled_components_browser_esm["default"])(Live/* Live */.v).withConfig({
    displayName: "HomeTVLiveIndicator__LiveIcon",
    componentId: "sc-2cf6ff9b-2"
})(HomeTVLiveIndicator_templateObject2(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var HomeTVLiveIndicator = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomeTVLiveIndicator_Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveIcon, {
                width: 21
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                children: _("LIVE STREAM")
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/modules/home/components/HomeTVSection/HomeTVSectionDesktop.tsx



function HomeTVSectionDesktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      transform: translateY(0);\n    "
    ]);
    HomeTVSectionDesktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HomeTVSectionDesktop_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 640px;\n  z-index: 0;\n  overflow: hidden;\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    transition: 250ms;\n    background-color: ",
        ";\n    transform: translateY(-168px);\n\n    ",
        ";\n  }\n"
    ]);
    HomeTVSectionDesktop_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HomeTVSectionDesktop_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        " {\n      cursor: unset;\n    }\n  "
    ]);
    HomeTVSectionDesktop_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HomeTVSectionDesktop_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding-bottom: 40px;\n  color: ",
        ";\n\n  transition: background-color 150ms\n      ",
        ",\n    color 150ms ",
        ";\n\n  ",
        " {\n    cursor: pointer;\n  }\n\n  ",
        "\n"
    ]);
    HomeTVSectionDesktop_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HomeTVSectionDesktop_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    opacity: 1;\n  "
    ]);
    HomeTVSectionDesktop_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HomeTVSectionDesktop_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 100%;\n  background: ",
        ";\n  color: ",
        ";\n  width: 29.94px;\n  height: 29.94px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity ",
        "s\n    ",
        ";\n\n  ",
        " {\n    left: auto;\n    right: 100%;\n  }\n\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n\n  ",
        "\n"
    ]);
    HomeTVSectionDesktop_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function HomeTVSectionDesktop_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  padding-bottom: 25px;\n"
    ]);
    HomeTVSectionDesktop_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function HomeTVSectionDesktop_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 600px;\n    grid-template-areas: 'player schedule';\n    grid-template-columns: 1fr 300px;\n    grid-template-rows: 600px;\n    grid-column-gap: 0;\n  "
    ]);
    HomeTVSectionDesktop_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function HomeTVSectionDesktop_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 25px;\n  padding-bottom: 25px;\n  padding-right: 0;\n  height: 480px;\n  position: relative;\n  display: grid;\n  grid-template-areas: 'summary . schedule' 'summary player schedule';\n  grid-template-columns: 250px 1fr 300px;\n  grid-template-rows: 35px 1fr;\n  grid-row-gap: 20px;\n  grid-column-gap: 16px;\n  z-index: 1;\n  ",
        " {\n    padding-right: 40px;\n    padding-left: 0;\n  }\n\n  ",
        ";\n"
    ]);
    HomeTVSectionDesktop_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function HomeTVSectionDesktop_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: white;\n  position: absolute;\n  top: -20px;\n  bottom: -20px;\n  clip-path: polygon(60px 0, 100% 0, 0 100%);\n  right: 275px;\n  width: 90px;\n  z-index: 0;\n  ",
        " {\n    left: 275px;\n    right: auto;\n    clip-path: polygon(0 0, calc(100% - 60px) 0, 100% 100%);\n  }\n"
    ]);
    HomeTVSectionDesktop_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function HomeTVSectionDesktop_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: summary;\n  min-height: 0;\n  min-width: 0;\n"
    ]);
    HomeTVSectionDesktop_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function HomeTVSectionDesktop_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -52px;\n  left: 0;\n  width: 100%;\n"
    ]);
    HomeTVSectionDesktop_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function HomeTVSectionDesktop_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 0;\n  "
    ]);
    HomeTVSectionDesktop_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function HomeTVSectionDesktop_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: player;\n  min-height: 0;\n  min-width: 0;\n  position: relative;\n  z-index: 1;\n  margin-bottom: -40px;\n\n  ",
        ";\n"
    ]);
    HomeTVSectionDesktop_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function HomeTVSectionDesktop_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n\n  && {\n    & > * > * {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n    }\n  }\n"
    ]);
    HomeTVSectionDesktop_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function HomeTVSectionDesktop_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 15px;\n    padding-bottom: 30px;\n  "
    ]);
    HomeTVSectionDesktop_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: schedule;\n  padding-left: 70px;\n  height: 100%;\n  gap: 16px;\n  ",
        " {\n    padding-left: 0;\n    padding-right: 70px;\n  }\n\n  display: flex;\n  flex-direction: column;\n\n  ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}





















var SectionBackground = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeTVSectionDesktop__SectionBackground",
    componentId: "sc-5cdb68f3-0"
})(HomeTVSectionDesktop_templateObject1(), (0,theme/* fromTheme */.HW)(function(theme) {
    return theme.palette.neauvia;
}), (0,casePathEmptyString/* casePathEmptyString */.Q)("$focusMode")((0,styled_components_browser_esm.css)(HomeTVSectionDesktop_templateObject())));
var HomeTVSectionDesktop_Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "HomeTVSectionDesktop__Section",
    componentId: "sc-5cdb68f3-1"
})(HomeTVSectionDesktop_templateObject3(), (0,theme/* fromTheme */.HW)(function(theme) {
    return theme.text.palette.primary;
}), (0,theme/* fromTheme */.HW)(function(theme) {
    return theme.animation.easing.accelerated;
}), (0,theme/* fromTheme */.HW)(function(theme) {
    return theme.animation.easing.accelerated;
}), Schedule, (0,casePathEmptyString/* casePathEmptyString */.Q)("$focusMode")((0,styled_components_browser_esm.css)(HomeTVSectionDesktop_templateObject2(), Schedule)));
var ExitFocusModeButton = (0,styled_components_browser_esm["default"])((0,motion/* motion */.E)(Button/* CleanButton */.ux)).withConfig({
    displayName: "HomeTVSectionDesktop__ExitFocusModeButton",
    componentId: "sc-5cdb68f3-2"
})(HomeTVSectionDesktop_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, function(param) {
    var theme = param.theme;
    return theme.palette.accent;
}, function(param) {
    var theme = param.theme;
    return theme.animation.duration;
}, (0,theme/* fromTheme */.HW)(function(theme) {
    return theme.animation.easing.default;
}), theme/* dirRTL */.gX, (0,casePathEmptyString/* casePathEmptyString */.Q)("$visible")((0,styled_components_browser_esm.css)(HomeTVSectionDesktop_templateObject4())));
var ContentWrapper = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "HomeTVSectionDesktop__ContentWrapper",
    componentId: "sc-5cdb68f3-3"
})(HomeTVSectionDesktop_templateObject6());
var Content = (0,motion/* motion */.E)((0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "HomeTVSectionDesktop__Content",
    componentId: "sc-5cdb68f3-4"
})(HomeTVSectionDesktop_templateObject8(), theme/* dirRTL */.gX, (0,casePathEmptyString/* casePathEmptyString */.Q)("$focusMode")((0,styled_components_browser_esm.css)(HomeTVSectionDesktop_templateObject7()))));
var Needle = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "HomeTVSectionDesktop__Needle",
    componentId: "sc-5cdb68f3-5"
})(HomeTVSectionDesktop_templateObject9(), theme/* dirRTL */.gX);
var SummaryContainer = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "HomeTVSectionDesktop__SummaryContainer",
    componentId: "sc-5cdb68f3-6"
})(HomeTVSectionDesktop_templateObject10());
var HomeTVSectionDesktop_LiveIndicator = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "HomeTVSectionDesktop__LiveIndicator",
    componentId: "sc-5cdb68f3-7"
})(HomeTVSectionDesktop_templateObject11());
var PlayerArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeTVSectionDesktop__PlayerArea",
    componentId: "sc-5cdb68f3-8"
})(HomeTVSectionDesktop_templateObject13(), (0,casePathEmptyString/* casePathEmptyString */.Q)("$focusMode")((0,styled_components_browser_esm.css)(HomeTVSectionDesktop_templateObject12())));
var PlayerContainer = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "HomeTVSectionDesktop__PlayerContainer",
    componentId: "sc-5cdb68f3-9"
})(HomeTVSectionDesktop_templateObject14(), (0,common.ar)(16 / 9));
var HomeTVSectionScheduleContainer = (0,styled_components_browser_esm["default"])(motion/* motion.aside */.E.aside).withConfig({
    displayName: "HomeTVSectionDesktop__HomeTVSectionScheduleContainer",
    componentId: "sc-5cdb68f3-10"
})(_templateObject16(), theme/* dirRTL */.gX, (0,casePathEmptyString/* casePathEmptyString */.Q)("$focusMode")((0,styled_components_browser_esm.css)(HomeTVSectionDesktop_templateObject15())));
var HomeTVSectionDesktop = function() {
    var schedule = (0,tvSchedule/* useTVScheduleQuery */.Vn)();
    var scheduleConfiguration = (0,tvScheduleConfiguration/* useTVScheduleConfigurationQuery */.T)();
    var loading = (0,react.useMemo)(function() {
        return schedule.isLoading || scheduleConfiguration.isLoading;
    }, [
        schedule.isLoading,
        scheduleConfiguration.isLoading
    ]);
    var isLoading = (0,useDelayedValue/* useDelayedValue */.t)(loading, 500);
    var ref = (0,react.useState)(false), focusMode = ref[0], setFocusMode = ref[1];
    var enterFocusMode = (0,react.useCallback)(function(e) {
        var ref;
        // Do not enter focus if user clicks on player buttons & overlays
        if ((ref = e === null || e === void 0 ? void 0 : e.target) === null || ref === void 0 ? void 0 : ref.matches('[data-no-focus-mode="true"] *, .w-bottom-bar *')) {
            return;
        }
        setFocusMode(true);
    }, [
        setFocusMode
    ]);
    var exitFocusMode = (0,react.useCallback)(function() {
        setFocusMode(false);
    }, [
        setFocusMode
    ]);
    var ref1 = (0,tvSchedule/* useCurrentTVSectionItem */.UL)(schedule.data, scheduleConfiguration.data), currentVideo = ref1.currentVideo, upcomingVideos = ref1.upcomingVideos;
    var isLive = (0,react.useMemo)(function() {
        return (currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.video) && (0,isLiveStream/* isLiveStream */.t)(currentVideo.video);
    }, [
        currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.video
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm.ThemeProvider, {
        theme: theme/* redTheme */.MN,
        children: (isLoading || upcomingVideos.length > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomeTVSectionDesktop_Section, {
            $focusMode: focusMode,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionBackground, {
                    $focusMode: focusMode
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                        $focusMode: focusMode,
                        children: [
                            !focusMode && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Needle, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
                                        fade: true,
                                        from: "leftMore"
                                    })), {
                                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                    width: "90%",
                                                    height: 40,
                                                    style: {
                                                        marginBottom: 20
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                    width: "90%",
                                                    height: 20
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                    width: "40%",
                                                    height: 20
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                    width: "80%",
                                                    height: 20
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                    width: "70%",
                                                    height: 20
                                                })
                                            ]
                                        }) : currentVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoSummary/* VideoSummary */.C, {
                                            video: currentVideo.video,
                                            moreButton: false
                                        })
                                    }))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PlayerArea, {
                                $focusMode: focusMode,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm.ThemeProvider, {
                                        theme: theme/* redTheme */.MN,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitFocusModeButton, {
                                            layout: true,
                                            onClick: exitFocusMode,
                                            $visible: focusMode,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* Close */.x, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm.ThemeProvider, {
                                        theme: theme/* darkTheme */.$_,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayerContainer, {
                                            layout: true,
                                            onClickCapture: enterFocusMode,
                                            children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm.ThemeProvider, {
                                                theme: theme/* redTheme */.MN,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                    fill: true
                                                })
                                            }) : currentVideo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    !focusMode && isLive && /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTVSectionDesktop_LiveIndicator, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
                                                        fade: true,
                                                        enterDelay: 0.2
                                                    })), {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTVLiveIndicator, {})
                                                    })),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NeauviaTVPlayer, {
                                                        video: currentVideo,
                                                        isFocused: focusMode
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTVSectionScheduleContainer, {
                                layout: true,
                                $focusMode: focusMode,
                                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                            width: "50%",
                                            height: 20,
                                            style: {
                                                marginBottom: 20
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: range_default()(5).map(function(num) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                    width: "100%",
                                                    height: 46
                                                }, num);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                    width: "40%",
                                                    height: 20
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                    width: "70%",
                                                    height: 40
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTVSectionSchedule, {
                                    onScheduleClick: enterFocusMode
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/simplebar-react/dist/simplebar-react.esm.js + 1 modules
var simplebar_react_esm = __webpack_require__(14863);
;// CONCATENATED MODULE: ./src/modules/home/components/HomeTVSection/HomeTVSectionMobile.tsx

function HomeTVSectionMobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n"
    ]);
    HomeTVSectionMobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HomeTVSectionMobile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 215px;\n"
    ]);
    HomeTVSectionMobile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HomeTVSectionMobile_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 180px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  padding-right: 0;\n  padding-left: 0;\n"
    ]);
    HomeTVSectionMobile_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HomeTVSectionMobile_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: calc(var(--constraint-container-right-margin));\n  padding-left: calc(var(--constraint-container-left-margin));\n"
    ]);
    HomeTVSectionMobile_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HomeTVSectionMobile_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: header;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 18px;\n  letter-spacing: 0.64rpx;\n  text-transform: uppercase;\n\n  ",
        ";\n"
    ]);
    HomeTVSectionMobile_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HomeTVSectionMobile_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  [data-simplebar] {\n    height: 100%;\n  }\n"
    ]);
    HomeTVSectionMobile_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function HomeTVSectionMobile_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: start;\n\n  ",
        ";\n"
    ]);
    HomeTVSectionMobile_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function HomeTVSectionMobile_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 1;\n    "
    ]);
    HomeTVSectionMobile_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function HomeTVSectionMobile_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 260px;\n  flex: 0 0 260px;\n  display: grid;\n  grid-template-areas: 'time title' '. tags' '. footer';\n  grid-template-columns: min-content auto 1fr;\n  grid-row-gap: 8px;\n  grid-column-gap: 10px;\n  padding-right: 20px;\n  transition: opacity 0.3s;\n  opacity: 0.5;\n  ",
        "\n"
    ]);
    HomeTVSectionMobile_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function HomeTVSectionMobile_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: time;\n  font-weight: 300;\n  letter-spacing: 0.64rpx;\n  line-height: 1.2;\n  text-align: right;\n"
    ]);
    HomeTVSectionMobile_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function HomeTVSectionMobile_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: title;\n  ",
        ";\n  line-height: 1.2;\n  min-height: 40px;\n"
    ]);
    HomeTVSectionMobile_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function HomeTVSectionMobile_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 10px;\n"
    ]);
    HomeTVSectionMobile_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function HomeTVSectionMobile_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: right;\n  margin-top: -2px;\n"
    ]);
    HomeTVSectionMobile_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function HomeTVSectionMobile_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: tags;\n  display: grid;\n  grid-template-columns: repeat(2, fit-content(75%));\n  grid-column-gap: 8px;\n  grid-template-rows: auto;\n  min-height: 0;\n"
    ]);
    HomeTVSectionMobile_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function HomeTVSectionMobile_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  line-height: 18px;\n  min-width: 0;\n  ",
        ";\n  ",
        ";\n"
    ]);
    HomeTVSectionMobile_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function HomeTVSectionMobile_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: footer;\n  display: grid;\n  grid-auto-flow: column;\n  grid-column-gap: 10px;\n  align-items: center;\n  justify-content: start;\n"
    ]);
    HomeTVSectionMobile_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function HomeTVSectionMobile_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 30px;\n  height: 30px;\n"
    ]);
    HomeTVSectionMobile_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  text-transform: uppercase;\n  text-align: right;\n  font-size: 14px;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}






















var HomeTVSectionMobile_Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "HomeTVSectionMobile__Section",
    componentId: "sc-c43eb8a0-0"
})(HomeTVSectionMobile_templateObject(), (0,theme/* fromTheme */.HW)(function(theme) {
    return theme.palette.background;
}), (0,theme/* fromTheme */.HW)(function(theme) {
    return theme.text.palette.primary;
}));
var HomeTVSectionMobile_Player = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeTVSectionMobile__Player",
    componentId: "sc-c43eb8a0-1"
})(HomeTVSectionMobile_templateObject1());
var HomeTVSectionMobile_Schedule = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).attrs({
    as: "aside"
}).withConfig({
    displayName: "HomeTVSectionMobile__Schedule",
    componentId: "sc-c43eb8a0-2"
})(HomeTVSectionMobile_templateObject2());
var containerPaddings = (0,styled_components_browser_esm.css)(HomeTVSectionMobile_templateObject3());
var HomeTVSectionMobile_Header = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "HomeTVSectionMobile__Header",
    componentId: "sc-c43eb8a0-3"
})(HomeTVSectionMobile_templateObject4(), containerPaddings);
var HomeTVSectionMobile_ScrollableContent = (0,styled_components_browser_esm["default"])(simplebar_react_esm/* default */.Z).withConfig({
    displayName: "HomeTVSectionMobile__ScrollableContent",
    componentId: "sc-c43eb8a0-4"
})(HomeTVSectionMobile_templateObject5());
var ScheduleList = styled_components_browser_esm["default"].ol.withConfig({
    displayName: "HomeTVSectionMobile__ScheduleList",
    componentId: "sc-c43eb8a0-5"
})(HomeTVSectionMobile_templateObject6(), containerPaddings);
var HomeTVSectionMobile_ScheduleItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "HomeTVSectionMobile__ScheduleItem",
    componentId: "sc-c43eb8a0-6"
})(HomeTVSectionMobile_templateObject8(), function(param) {
    var $active = param.$active;
    return $active && (0,styled_components_browser_esm.css)(HomeTVSectionMobile_templateObject7());
});
var ScheduleTime = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeTVSectionMobile__ScheduleTime",
    componentId: "sc-c43eb8a0-7"
})(HomeTVSectionMobile_templateObject9());
var ScheduleTitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeTVSectionMobile__ScheduleTitle",
    componentId: "sc-c43eb8a0-8"
})(HomeTVSectionMobile_templateObject10(), (0,common/* lineClamp */.Sf)(2));
var StyledHomeTVLiveIndicator = (0,styled_components_browser_esm["default"])(HomeTVLiveIndicator).withConfig({
    displayName: "HomeTVSectionMobile__StyledHomeTVLiveIndicator",
    componentId: "sc-c43eb8a0-9"
})(HomeTVSectionMobile_templateObject11());
var ScheduleLock = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeTVSectionMobile__ScheduleLock",
    componentId: "sc-c43eb8a0-10"
})(HomeTVSectionMobile_templateObject12());
var ScheduleTags = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeTVSectionMobile__ScheduleTags",
    componentId: "sc-c43eb8a0-11"
})(HomeTVSectionMobile_templateObject13());
var Tag = styled_components_browser_esm["default"].span.withConfig({
    displayName: "HomeTVSectionMobile__Tag",
    componentId: "sc-c43eb8a0-12"
})(HomeTVSectionMobile_templateObject14(), (0,polished_esm/* ellipsis */.LH)("100%"), (0,polished_esm/* wordWrap */.BW)("nowrap"));
var ScheduleFooter = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeTVSectionMobile__ScheduleFooter",
    componentId: "sc-c43eb8a0-13"
})(HomeTVSectionMobile_templateObject15());
var HomeTVSectionMobile_StyledAvatar = (0,styled_components_browser_esm["default"])(Avatar/* Avatar */.qE).withConfig({
    displayName: "HomeTVSectionMobile__StyledAvatar",
    componentId: "sc-c43eb8a0-14"
})(HomeTVSectionMobile_templateObject16());
var HomeTVSectionMobile_ScheduleItemSubtitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HomeTVSectionMobile__ScheduleItemSubtitle",
    componentId: "sc-c43eb8a0-15"
})(_templateObject17());
var HomeTvSectionMobile = function() {
    var translateItem = (0,useTranslateItem/* useTranslateItem */.L)();
    var schedule = (0,tvSchedule/* useTVScheduleQuery */.Vn)();
    var scheduleConfiguration = (0,tvScheduleConfiguration/* useTVScheduleConfigurationQuery */.T)();
    var loading = (0,react.useMemo)(function() {
        return schedule.isLoading || scheduleConfiguration.isLoading;
    }, [
        schedule.isLoading,
        scheduleConfiguration.isLoading
    ]);
    var isLoading = (0,useDelayedValue/* useDelayedValue */.t)(loading, 500);
    var ref = (0,tvSchedule/* useCurrentTVSectionItem */.UL)(schedule.data, scheduleConfiguration.data), currentVideo = ref.currentVideo, upcomingVideos = ref.upcomingVideos, currentProgramme = ref.currentProgramme, nextProgramme = ref.nextProgramme;
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm.ThemeProvider, {
        theme: theme/* redTheme */.MN,
        children: isLoading || currentVideo && upcomingVideos.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomeTVSectionMobile_Section, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTVSectionMobile_Player, {
                    children: currentVideo && !isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NeauviaTVPlayer, {
                        video: currentVideo
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomeTVSectionMobile_Schedule, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTVSectionMobile_Header, {
                            children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                width: "50%",
                                height: 20
                            }) : _("TODAY PROGRAM")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTVSectionMobile_ScrollableContent, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduleList, {
                                children: isLoading ? range_default()(3).map(function(num) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTVSectionMobile_ScheduleItem, {
                                        $active: false,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                    width: "120px",
                                                    height: 20
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                    width: "80px",
                                                    height: 40
                                                })
                                            ]
                                        })
                                    }, num);
                                }) : upcomingVideos.map(function(a) {
                                    var isLive = (0,isLiveStream/* isLiveStream */.t)(a.video);
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomeTVSectionMobile_ScheduleItem, {
                                        $active: a === currentProgramme,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScheduleTime, {
                                                children: [
                                                    a === currentProgramme && /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTVSectionMobile_ScheduleItemSubtitle, {
                                                        children: _("now")
                                                    }),
                                                    a === nextProgramme && /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTVSectionMobile_ScheduleItemSubtitle, {
                                                        children: _("Next")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatHour */.t, {
                                                        children: a.startDate
                                                    }),
                                                    !(0,permissions/* canUserAccessItem */.k)(a.video) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduleLock, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lock/* Lock */.H, {
                                                            size: 12
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScheduleTitle, {
                                                children: [
                                                    isLive && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHomeTVLiveIndicator, {}),
                                                    a.video.name
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduleTags, {
                                                children: a.video.tags.slice(0, 2).map(function(t) {
                                                    return t.tags_id;
                                                }).map(translateItem).map(function(b) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                                                        children: b.name
                                                    }, b.name);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduleFooter, {
                                                children: a.video.speakers.slice(0, 2).map(function(b) {
                                                    var ref;
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(HomeTVSectionMobile_StyledAvatar, {
                                                        src: (ref = b.people_id.avatar) === null || ref === void 0 ? void 0 : ref.id
                                                    }, b.people_id.id);
                                                })
                                            })
                                        ]
                                    }, a.startDate);
                                })
                            })
                        })
                    ]
                })
            ]
        }) : null
    });
};

;// CONCATENATED MODULE: ./src/modules/home/components/HomeTVSection/index.tsx






var HomeTVSection = (0,WithSilentErrorBoundary/* withSilentErrorBoundary */.o)(function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* Media */.pU, {
                lessThan: "desktop",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTvSectionMobile, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* Media */.pU, {
                greaterThanOrEqual: "desktop",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTVSectionDesktop, {})
            })
        ]
    });
});

// EXTERNAL MODULE: ./src/components/seo/MetaTitle.tsx
var MetaTitle = __webpack_require__(71508);
// EXTERNAL MODULE: ./src/components/seo/MetaDescription.tsx
var MetaDescription = __webpack_require__(89080);
;// CONCATENATED MODULE: ./src/pages/index.tsx










var IndexPage = function() {
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTitle/* MetaTitle */.p, {
                children: _("Scientific Videos, Live Events and Training")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaDescription/* MetaDescription */.l, {
                children: _("Discover the first 24/7 aesthetic medicine channel dedicated to doctors. Get free access to online scientific on-demand videos, training and online events")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTVSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeFeaturedSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeProtocolsSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeLearnByCaseSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeBusinessCasesSection, {})
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (IndexPage);


/***/ }),

/***/ 9570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ iOS; }
/* harmony export */ });
var iOS = function() {
    if (true) {
        return [
            "iPad Simulator",
            "iPhone Simulator",
            "iPod Simulator",
            "iPad",
            "iPhone",
            "iPod", 
        ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
    }
    return false;
};


/***/ }),

/***/ 97182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useTimeout; }
});

// EXTERNAL MODULE: ./node_modules/react-use/esm/useTimeoutFn.js
var useTimeoutFn = __webpack_require__(34513);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-use/esm/useUpdate.js

var updateReducer = function (num) { return (num + 1) % 1000000; };
function useUpdate() {
    var _a = (0,react.useReducer)(updateReducer, 0), update = _a[1];
    return update;
}

;// CONCATENATED MODULE: ./node_modules/react-use/esm/useTimeout.js


function useTimeout(ms) {
    if (ms === void 0) { ms = 0; }
    var update = useUpdate();
    return (0,useTimeoutFn/* default */.Z)(update, ms);
}


/***/ }),

/***/ 97277:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nboostlogo.9e9ea2d3.svg";

/***/ }),

/***/ 69909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nliftlogo.9e9fdd57.svg";

/***/ }),

/***/ 25759:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nroselogo.e2878bfd.svg";

/***/ })

}]);